// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:56:54.466Z
// Property: Wynnewood Farms (ID: 6767906449167624)
// Collections: 42 amenities, 12 floorplans (live), 32 photos, 77 POIs, 16 reviews, 7 virtual tours, 6 office hours, 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167624",
  "property_external_id": "1124410",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/wynnewood-farms-overland-park-ks/6fpvt8v/",
  "property_google_business_url": "https://www.google.com/maps/place/Wynnewood+Farms+Apartment+Homes/@38.8855446,-94.6479623,891m/data=!3m1!1e3!4m15!1m8!3m7!1s0x87c0c1f9d222abdd:0xe2f0f6086753bc49!2s5433+W+133rd+Terrace,+Overland+Park,+KS+66209!3b1!8m2!3d38.8856237!4d-94.6482638!16s%2Fg%2F11bw3_926x!3m5!1s0x87c0c1f9a3318dd7:0xd6b823e35b17ca0b!8m2!3d38.8867096!4d-94.648426!16s%2Fg%2F1th24b09?entry=ttu&g_ep=EgoyMDI2MDkxNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "39401883318",
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124410 p1099361",
  "property_status": null,
  "property_slug": "wynnewood-farms",
  "property_name": "Wynnewood Farms",
  "property_website_url": "https://www.wynnewoodfarms.com/",
  "property_domain": "https://www.wynnewoodfarms.com/",
  "property_address": "5433 W 133rd Terrace",
  "property_full_address": "5433 W 133rd Terrace, Overland Park, KS 66209",
  "property_address_1": "5433 W 133rd Terrace",
  "property_address_2": null,
  "property_address_city": "Overland Park",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66209",
  "property_address_country": "US",
  "property_address_county": "Johnson County",
  "property_neighborhood_address": "Wynnewood",
  "property_address_latitude": "38.8856237",
  "property_address_longitude": "-94.6482638",
  "property_email": "rentcafe.wf@pricekc.com",
  "property_phone": "(913) 675-9278",
  "property_call_tracking_phone": "913-675-9278",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>South Overland Park living with room to breathe.</strong> Explore polished one-, two-, and three-bedroom homes with select attached garages, in-home washers and dryers, elevated finishes, and everyday community comforts—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Wynnewood Farms for yourself.</p>",
  "property_long_description": "<p>Wynnewood Farms offers apartments in Overland Park, KS, just north of 135th Street near Nall Avenue. The community is managed by Price Brothers Management, a Kansas City family-owned company since 1922.</p><p>Every apartment at Wynnewood Farms has 9-foot ceilings with crown molding, a breakfast bar, a large garden tub, and an in-home washer and dryer. Select homes add an attached garage, a den, or a built-in desk. Residents also have a swimming pool, a 24-hour fitness center, a business center, a car care center, and a Bark Bar for pets.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-8dd9-71ec-b5d4-bd844300502c.webp",
  "property_featured_image_media": {
    "alt_text": "Dining area with a round table and chairs next to a kitchen.",
    "public_id": "01a0b67b-8dd9-71ec-b5d4-bd844300502c",
    "storage_key": "property/6767906449167624/01a0b67b-8dd9-71ec-b5d4-bd844300502c.webp",
    "width": 1200,
    "height": 800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "232",
  "property_year_built": "2000",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.67241379310344",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-375",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://wynnewoodfarms.securecafeapplicant.com/onlineleasing/content3/access/wynnewood-farms/floorplans",
  "property_resident_portal_url": "https://wynnewoodfarms.securecafe.com/residentservices/wynnewood-farms/userlogin.aspx",
  "property_apply_now_url": "https://wynnewoodfarms.securecafeapplicant.com/onlineleasing/content3/access/wynnewood-farms/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc98f-8a22-7393-ae1e-2a4979c4ebe1.webp",
  "property_primary_logo_media": {
    "alt_text": "Wynnewood Farms logo",
    "public_id": "019fc98f-8a22-7393-ae1e-2a4979c4ebe1",
    "storage_key": "property/6767906449167624/019fc98f-8a22-7393-ae1e-2a4979c4ebe1.webp",
    "width": 1200,
    "height": 750
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a01009-0e2b-714e-a70d-748de4e5bbaa.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a01009-0e2b-714e-a70d-748de4e5bbaa",
    "storage_key": "property/6767906449167624/01a01009-0e2b-714e-a70d-748de4e5bbaa.webp",
    "width": 1200,
    "height": 750
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a01009-01ce-76cf-9ee8-2abfeaa27642.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a01009-01ce-76cf-9ee8-2abfeaa27642",
    "storage_key": "property/6767906449167624/01a01009-01ce-76cf-9ee8-2abfeaa27642.webp",
    "width": 1200,
    "height": 750
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#007041",
  "property_secondary_color": "#00573F",
  "property_font_color": null,
  "property_color_4": "#FCA311",
  "property_color_3": "#004976",
  "property_color_5": "#FED766",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "696 - 1415",
  "property_sqft_min": "696",
  "property_sqft_max": "1415",
  "property_price_range": "1517 - 8042",
  "property_price_min": "1517",
  "property_price_max": "8042",
  "property_available_units": 17,
  "property_facebook_url": "https://www.facebook.com/WynnewoodFarms",
  "property_instagram_url": "https://www.instagram.com/wynnewoodfarms/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ3asi0vnBwIcRSbxTZwj28OI",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Wynnewood Farms",
  "property_home_romance_title": "Embrace Life and Love in Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Amenities with real staying power.</strong> Start with a 24-hour fitness center, clubhouse coffee, business center, and pool, then add everyday helpers like package service, online services, on-site maintenance, recycling, and a car care center.</p><p>Inside, find in-home washers and dryers, 9-foot ceilings with crown molding, spacious closets, breakfast bars, and garden tubs—plus select upgrades like attached garages, granite countertops, stainless steel appliances, built-in desks, plank flooring, and private outdoor storage.</p>",
  "property_home_floorplans_blurb": "<p><strong>Choose a layout that lives the way you do.</strong> Wynnewood Farms offers one-, two-, and three-bedroom apartments in Overland Park, from efficient spaces to roomier homes with added storage and select attached garages. Look for everyday upgrades like in-home washers and dryers, spacious closets, all-electric kitchens with breakfast bars, 9-foot ceilings with crown molding, garden tubs, and private balconies or patios in select floor plans.</p>",
  "property_home_gallery_blurb": "<p><strong>See Wynnewood Farms in focus.</strong> Preview open, light-filled interiors with crown molding, breakfast bars, select granite counters, stainless steel finishes, garden tubs, spacious closets, and balconies or patios. Then explore community views featuring landscaped courtyards, poolside spaces, the clubhouse, and fitness center—all waiting in the full gallery.</p>",
  "property_home_neighborhood_blurb": "<p>Prairiefire and Parkway Plaza are right down the street from Wynnewood Farms, and Town Center Plaza is a short drive north on Nall Avenue. <a href=\"/neighborhood\">Explore the neighborhood.</a></p>",
  "property_home_reviews_blurb": "<p><strong>Residents highlight the everyday ease:</strong> quick maintenance, a welcoming office team, spacious floor plans, and beautifully kept grounds with mature trees and scenic walking areas. Reviews also call out the calm Overland Park setting near shopping, dining, and entertainment—plus shared spaces that make Wynnewood Farms feel easy to recommend. In the words of one resident: “Great place to call home!”</p>",
  "property_neighborhood_blurb": "<p>Wynnewood Farms is located just north of 135th Street near Nall Avenue in Overland Park, KS, a short walk or quick drive from Prairiefire’s restaurants, entertainment, shops, and the Museum at Prairiefire.</p><p>Looking for a place to eat near Wynnewood Farms? Our team recommends The Brass Onion, Kyoto Sushi &amp; Steak, KPOT Korean BBQ &amp; Hot Pot, and Wok &amp; Roll Express. Betty Rae’s Ice Cream is the go-to for dessert. For a night out, try BRKTHROUGH Overland Park’s challenge rooms and self-pour tap wall, or Chicken N Pickle for food and pickleball.</p><p>Parkway Plaza is nearby for everyday errands, and Corbin Park has Hen House Market and Sprouts Farmers Market, along with Maggiano’s Little Italy and Snooze. Town Center Plaza is a short drive north on Nall Avenue.</p><p>For time outdoors, visit Ironwoods Park in neighboring Leawood, or stay active at the Blue Valley Recreation Center at Hilltop. Menorah Medical Center and Saint Luke’s South Hospital are a short drive from Wynnewood Farms, and 135th Street connects to US-69.</p><p>Explore the neighborhood map above to find more destinations near Wynnewood Farms.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At Wynnewood Farms, the amenities are built around the little things that make daily life easier.</p><p>Spend summer afternoons at the sparkling swimming pool, fit in a workout at the 24-hour fitness center, or tackle your to-do list in the business center with copy and fax services. The car care center and free gift wrapping station add convenience you’ll appreciate year-round, and the Bark Bar is there for your four-legged friends.</p><p>Covered parking is available, with garage parking in select units, and high-speed internet access keeps you connected. Beautiful landscaping, monthly resident events, on-call emergency maintenance, available accessibility features, and flexible rent payment options make our luxury apartments in Overland Park, KS feel even more like home. Public parks with hiking and biking trails are nearby, along with easy access to freeways, shopping, and public transportation.</p><p>Inside your 1-, 2-, or 3-bedroom apartment home, you’ll find 9-foot ceilings with crown molding, a breakfast bar, a large garden tub, and a washer and dryer.</p><p>Browse the full list of community and apartment amenities above.</p>",
  "property_applynow_blurb": "<p><strong>Ready for South Overland Park living with room to breathe?</strong> Start your application online for a one-, two-, or three-bedroom apartment at Wynnewood Farms, where polished finishes, spacious closets, in-home washers and dryers, and everyday community conveniences make coming home feel easy.</p>",
  "property_contactus_blurb": "<p>Curious about garage availability, <a href=\"/floor-plans\">floor plans</a>, or lease options? The Wynnewood Farms leasing team is here to help with current availability, pets, parking, community amenities, and more.</p><p>Call us, stop by the leasing office, or send a message using the form above. We’d love to help you find your next home in Overland Park, KS.</p>",
  "property_faqs_blurb": "<p>Find answers to common questions about qualifications, applying, lease terms, pets, parking, and resident services at Wynnewood Farms in Overland Park, KS. Have a question we didn’t cover? The Wynnewood Farms <a href=\"/contact-us\">leasing team</a> is happy to help.</p>",
  "property_floorplans_blurb": "<p>Wynnewood Farms offers Overland Park apartments for a wide range of routines, from a cozy one-bedroom to a three-bedroom with space to spread out.</p><p>Every apartment at Wynnewood Farms includes an open floor plan, 9-foot ceilings with crown molding, an all-electric kitchen with a breakfast bar, spacious closets, a large garden tub, and a washer and dryer. Select homes add granite countertops, stainless steel appliances, wood-style vinyl flooring, under-cabinet lighting, double vanity sinks, a den or study, a built-in desk, or a private patio or balcony with extra storage.</p><p>Do Wynnewood Farms floor plans include a garage? Several layouts come with an attached garage. Check availability above, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite in person.</p>",
  "property_gallery_blurb": "<p>A quick scroll says a lot about Wynnewood Farms. The gallery features interior, exterior, and amenity photos from around our apartments in Overland Park.</p><p>Take a closer look at open living areas with crown molding, kitchens with breakfast bars, and bathrooms with large garden tubs. Then explore the swimming pool, fitness center, business center, and landscaped grounds.</p><p>Ready for the real thing? <a href=\"/schedule-a-tour\">Schedule a tour</a> to see Wynnewood Farms in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore South Overland Park.</strong> Use the interactive map to browse available <a href=\"/floor-plans\">one-, two-, and three-bedroom apartments</a> at Wynnewood Farms, then see what’s nearby around 135th Street and Nall Avenue—from shopping and dining to parks, trails, and entertainment in the <a href=\"/neighborhood\">Wynnewood neighborhood</a>.</p>",
  "property_pets_blurb": "<p>Wynnewood Farms offers pet-friendly apartments in Overland Park, KS, and welcomes dogs and cats. The community has an on-site Bark Bar, and every pet owner joins the <a href=\"https://www.pricebrotherskc.com/petroyaltyclub/\" target=\"_blank\">Price Brothers Pet Royalty Club</a> with the one-time pet fee, which includes discounts at local pet businesses.</p><p>Up to two pets are allowed per apartment. Monthly pet rent is $25 per pet, and the non-refundable pet fee is $300 for one pet or $500 for two pets. Restricted breeds include Pit Bulls, American Staffordshire Terriers, Rottweilers, German Shepherds, Malamutes, Doberman Pinschers, Chows, Great Danes, Saint Bernards, Akitas, wolf hybrids, and mixes of these breeds. Exotic, feral, wild, or inherently dangerous animals are not permitted.</p><p><a href=\"/contact-us\">Contact the Wynnewood Farms leasing team</a> for complete pet guidelines.</p>",
  "property_referafriend_blurb": "<p><strong>Share South Overland Park living with room to breathe.</strong><br>Love the polished layouts, select attached garages, in-home washers and dryers, sparkling pool, fitness center, and pet-friendly perks? Invite friends to discover Wynnewood Farms and see what makes everyday living here feel easy.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access made easy.</strong><br>Log in to pay rent, submit maintenance requests, and manage your Wynnewood Farms account—so you can get back to enjoying your South Overland Park home base with room to breathe.</p>",
  "property_reviews_blurb": "<p><strong>What residents are saying:</strong> Reviews for Wynnewood Farms point to the details that make daily life feel easier: responsive maintenance, a friendly office team, spacious layouts, and well-kept grounds with mature trees and scenic places to walk.</p><p>Residents often mention feeling welcomed, getting service requests handled quickly, and enjoying a calm community setting close to shopping, dining, and entertainment. From practical floor plans to inviting shared spaces, the feedback is consistent: Wynnewood Farms is a place residents are happy to recommend. As one reviewer put it, “Great place to call home!”</p>",
  "property_created_at": "1785792977532",
  "property_scheduletour_blurb": "<p>Walking through a home tells you more than any photo can. Schedule a tour of Wynnewood Farms to explore available <a href=\"/floor-plans\">floor plans</a>, see the pool and fitness center, and ask about homes with attached garages.</p><p>Our leasing team will be ready to answer your questions along the way. Choose a tour time above to get started.</p>",
  "property_thankyou_blurb": "<p><strong>Thanks for reaching out to Wynnewood Farms.</strong> We’ve received your inquiry, and our leasing team will follow up soon. In the meantime, picture South Overland Park living with room to breathe—polished one-, two-, and three-bedroom homes, thoughtful finishes, and everyday conveniences that make coming home feel easy.</p>",
  "property_virtualtours_blurb": "<p>Start your search from anywhere with Wynnewood Farms virtual tours. Walk through our one-, two-, and three-bedroom apartments in Overland Park, KS, and get a feel for each layout.</p><p>Keep an eye out for 9-foot ceilings, crown molding, breakfast bars, and garden tubs as you explore.</p><p>Like what you see? <a href=\"/schedule-a-tour\">Schedule a tour</a> or <a href=\"/floor-plans\">compare floor plans</a> to take the next step.</p>",
  "property_copyright": "2026 All Rights Reserved. Wynnewood Farms",
  "property_seo_title_home": "Wynnewood Farms | Apartments Overland Park, KS",
  "property_seo_description_home": "Wynnewood Farms offers apartments in Overland Park, KS near Prairiefire, with 1 to 3 bedroom homes, attached garages in select homes, and a pool.",
  "property_seo_title_floorplans": "Floor Plans | Overland Park Apartments with Garage",
  "property_seo_description_floorplans": "Compare 1, 2, and 3 bedroom Overland Park apartments at Wynnewood Farms, featuring layouts with an attached garage.",
  "property_seo_title_amenities": "Amenities | Luxury Apartments Overland Park",
  "property_seo_description_amenities": "Explore luxury apartments in Overland Park, KS at Wynnewood Farms, with a pool, 24-hour fitness center, car care center, Bark Bar, and more.",
  "property_seo_title_gallery": "Gallery | Apartments in Overland Park",
  "property_seo_description_gallery": "Browse photos of Wynnewood Farms, apartments in Overland Park with 9-foot ceilings, garden tubs, private patios, a swimming pool, and more.",
  "property_seo_title_virtualtours": "Virtual Tours | Apartments in Overland Park, KS",
  "property_seo_description_virtualtours": "Take a virtual tour of Wynnewood Farms in Overland Park, KS. Explore our 1, 2, and 3 bedroom floor plans online anytime.",
  "property_seo_title_interactivemap": "Interactive Map | Wynnewood Farms Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Wynnewood Farms in Overland Park! Explore spacious apartments and vibrant community events with our interactive map.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments Near Prairiefire",
  "property_seo_description_neighborhood": "Wynnewood Farms offers apartments near Prairiefire in Overland Park, KS, close to Parkway Plaza, Corbin Park, Town Center Plaza, and 135th Street dining.",
  "property_seo_title_contact": "Contact Us | Luxury Apartments in Overland Park, KS",
  "property_seo_description_contact": "Contact Wynnewood Farms in Overland Park, KS. Call or send a message to ask about availability, garages, and tours.",
  "property_seo_title_faqs": "FAQs | Overland Park Apartments",
  "property_seo_description_faqs": "Get answers about applying, pets, parking, utilities, & more at Wynnewood Farms, offering apartments in Overland Park, KS near Prairiefire.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Overland Park, KS",
  "property_seo_description_reviews": "Experience life at Wynnewood Farms in Overland Park, KS. Read genuine resident reviews and see why our vibrant community feels like home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Overland Park, KS",
  "property_seo_description_applynow": "Experience modern living at Wynnewood Farms in Overland Park, KS. Choose from spacious floor plans with top-tier amenities. Lease your new home online today!",
  "property_seo_title_residentaccess": "Resident Access | Wynnewood Farms",
  "property_seo_description_residentaccess": "Access the Wynnewood Farms resident portal for easy rent payments, maintenance requests, and community updates in Overland Park, KS!",
  "property_seo_title_referafriend": "Refer A Friend | Wynnewood Farms",
  "property_seo_description_referafriend": "Refer a friend to Wynnewood Farms in Overland Park, KS! Great friends make great neighbors. Spread the joy of community living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Apartments Overland Park KS",
  "property_seo_description_scheduletour": "Tour Wynnewood Farms, offering apartments in Overland Park, KS near 135th Street and Nall Avenue. Book a tour of our 1, 2, and 3 bedroom homes today.",
  "property_seo_title_privacy": "Privacy Policy | Wynnewood Farms",
  "property_seo_description_privacy": "At Wynnewood Farms in Overland Park, KS, your privacy matters. Read our policy to learn how we protect your information while you enjoy your home.",
  "property_seo_title_accessibility": "Website Accessibility | Wynnewood Farms",
  "property_seo_description_accessibility": "Experience seamless living at Wynnewood Farms in Overland Park, KS. We prioritize accessibility for all—join a community where everyone feels at home!",
  "property_seo_title_sitemap": "Sitemap | Wynnewood Farms",
  "property_seo_description_sitemap": "Uncover the charm of Wynnewood Farms in Overland Park, KS. Navigate our sitemap to easily find your perfect apartment and community amenities today!",
  "property_seo_title_thankyou": "Thank You | Wynnewood Farms",
  "property_seo_description_thankyou": "Thank you for reaching out to Wynnewood Farms in Overland Park! Our team will connect with you soon to help you find your perfect home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Overland Park Pet Friendly Apartments",
  "property_seo_description_pets": "Find pet friendly apartments in Overland Park at Wynnewood Farms, with an on-site Bark Bar and Pet Royalty Club perks. View our pet policy.",
  "property_updated_at": "1793743014619",
  "amenities": [
    {
      "id": "ec_097cb63f069b812efd2de561",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944693",
      "title": "Covered Parking Available, Garage Parking with Select Units*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f639749039fc2db174812f50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944707",
      "title": "Sparkling Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_596b0380ad72c92a33528d28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944684",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3af252bb2ef5ed816ab43c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944689",
      "title": "Car Care Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d9465c46e7ebb7a55f6873a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944683",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7b9e269cd908ae66d59b4918",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944698",
      "title": "Free Gift Wrapping Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e451003280a8476ed444a5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87982992",
      "title": "Bark Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fe4849313cce8dfa4801ed33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944687",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e205be53307715ede836bd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944703",
      "title": "Monthly Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44dc46137664babd80fc2831",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944704",
      "title": "On-Call Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_98e4da2aebd005624002dbf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944701",
      "title": "High-Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c0750cef1577b6dbdad230f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944695",
      "title": "Easy Access to Freeways, Shopping and Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_05c6eb3d2ae78e8899bd065e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944702",
      "title": "Hiking and Biking Trails with Public Parks Nearby",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6563b29f5f02a8cc49778308",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944694",
      "title": "Disability Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77d1d2f675022b712b6365d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944692",
      "title": "Copy and Fax Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6ca7dc95d8497cc76c455472",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "122755418",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c1bb7be80d377ebb78cbb464",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944724",
      "title": "Open Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c9632ab9c74d7291aedf6b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944729",
      "title": "Washer and Dryer Included",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_47a789e9b5b08d2e8c8f20c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944711",
      "title": "Attached Garage*",
      "amount": "false",
      "description": "*with Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e536809cc3b9e43002396775",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944709",
      "title": "All-Electric Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-9b1f-738f-9da2-3517e8248d5c.webp",
      "amenity_image_media": {
        "alt_text": "White kitchen with stainless steel sink, white cabinets, and white appliances.",
        "public_id": "01a0b67b-9b1f-738f-9da2-3517e8248d5c",
        "storage_key": "property/6767906449167624/01a0b67b-9b1f-738f-9da2-3517e8248d5c.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A white kitchen with wood floors and white appliances at Wynnewood Farms Apartments, Overland Park, KS, 66209",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c5d69b06e0553541177bd23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944726",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6bcd61614aa672df5f60546d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944725",
      "title": "Private Balconies and Patios with Extra Storage*",
      "amount": "false",
      "description": "*with Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_042f8d912f047e4555e3fe4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "90506055",
      "title": "Wood-Style Vinyl Flooring Throughout*",
      "amount": "false",
      "description": "*Excluding Bedrooms / in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ed8dc2c2c9fa7192bbf3a46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944708",
      "title": "9ft Ceilings with Crown Molding",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d0a17cdcd8b7bef747f136c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944710",
      "title": "Art Niche*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f567276d9ee3e0a2d024dca0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944719",
      "title": "Den or Study*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d56a811b4b89b597eb5edb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944712",
      "title": "Breakfast Bar",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_65487d2c8af0de06b4444208",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944713",
      "title": "Built-in Desk*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-9b0b-76ca-a4c4-f48c711a504b.webp",
      "amenity_image_media": {
        "alt_text": "A home office area with a built-in desk and bookshelves next to a large window.",
        "public_id": "01a0b67b-9b0b-76ca-a4c4-f48c711a504b",
        "storage_key": "property/6767906449167624/01a0b67b-9b0b-76ca-a4c4-f48c711a504b.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A room with a desk, chair, and bookshelf at Wynnewood Farms Apartments, Overland Park 66209,A white desk with a chair and a bookshelf with books. at Wynnewood Farms Apartments, Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_239da0434fac8be12f65353d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944722",
      "title": "Double Vanity Sinks in Main Bath*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0f1edd8ecc245a230c135ec0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944723",
      "title": "Large Garden Tubs",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a7a35ca5a14f1e48d36c6047",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "122010318",
      "title": "Granite Countertops*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8617dd714a3c4fb811cee77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "122011632",
      "title": "Upgraded Dark Cabinets*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4b81e0ee5853d243f92acbd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944727",
      "title": "Under-Cabinet Lighting*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_742b4fa089d96a9e1dade9ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944728",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_597acb65162d6ab82ed5801c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944716",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25f75eef7eece5ffc1e81e4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944715",
      "title": "Carpeted Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-9b1a-7579-8064-1b6c1bbae346.webp",
      "amenity_image_media": {
        "alt_text": "Dining area and kitchen with white cabinets and appliances in an apartment.",
        "public_id": "01a0b67b-9b1a-7579-8064-1b6c1bbae346",
        "storage_key": "property/6767906449167624/01a0b67b-9b1a-7579-8064-1b6c1bbae346.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A dining room with a table set for two and a chandelier hanging from the ceiling. at Wynnewood Farms Apartments, Overland Park,A bedroom with a bed, a plant, and two framed pictures on the wall. at Wynnewood Farms Apartments, Overland Park, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_95a42541cd56e608a8bdeb89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "87944720",
      "title": "Disability Access Available*",
      "amount": "false",
      "description": "*for Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4bc0a68add0ac0a65f7cd224",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "126641461",
      "title": "Brushed Nickel Fixtures*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0796ea1e6301920585349ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "126641462",
      "title": "White Cabinets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_65bde6670594513f19cce890",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "126641464",
      "title": "Tile Backsplash*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5b59859169db6afd516a5324",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "126641465",
      "title": "Microwave*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9e886dbf61f8e1e46169088",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "external_id": "126641466",
      "title": "Upgraded Lighting*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_064ea900b2d37a0392812e57",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-8dd9-71ec-b5d4-bd844300502c.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and chairs next to a kitchen.",
        "public_id": "01a0b67b-8dd9-71ec-b5d4-bd844300502c",
        "storage_key": "property/6767906449167624/01a0b67b-8dd9-71ec-b5d4-bd844300502c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this open-concept dining area, perfect for meals and entertaining, adjacent to a well-equipped kitchen.",
      "link": "false",
      "alt_text": "Dining area with a round table and chairs next to a kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/20-IMG_1661-HDR_final.jpg"
    },
    {
      "id": "ec_347e7dfbb02c62caecf1453b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-bcb5-72b8-b916-c5951c02a66a.webp",
      "image_media": {
        "alt_text": "Built-in desk with shelves and chair in an apartment.",
        "public_id": "01a0b67b-bcb5-72b8-b916-c5951c02a66a",
        "storage_key": "property/6767906449167624/01a0b67b-bcb5-72b8-b916-c5951c02a66a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Work from home in this dedicated home office space, featuring a built-in desk with ample shelving and a comfortable chair.",
      "link": "false",
      "alt_text": "Built-in desk with shelves and chair in an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-IMG_1593-HDR_final.jpg"
    },
    {
      "id": "ec_2b1f997f0a4020a3d1f3d65c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-bcd1-752b-b322-9670e7432e7a.webp",
      "image_media": {
        "alt_text": "Cozy living room with a plush sofa, modern coffee table, and abstract art.",
        "public_id": "01a0b67b-bcd1-752b-b322-9670e7432e7a",
        "storage_key": "property/6767906449167624/01a0b67b-bcd1-752b-b322-9670e7432e7a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in this inviting living space featuring a comfortable sofa, elegant coffee tables, and stylish decor. Perfect for unwinding or entertaining guests.",
      "link": "false",
      "alt_text": "Cozy living room with a plush sofa, modern coffee table, and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/19-IMG_1648_final.jpg"
    },
    {
      "id": "ec_5d4e39001994104d20f52d59",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-a8bc-752f-b451-99e14f5972c6.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and mounted TV, view into a den with a desk and window.",
        "public_id": "01a0b67b-a8bc-752f-b451-99e14f5972c6",
        "storage_key": "property/6767906449167624/01a0b67b-a8bc-752f-b451-99e14f5972c6.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a white fireplace with a mounted flat-screen TV, and an adjacent den with a desk and natural light from a large window.",
      "link": "false",
      "alt_text": "Living room with fireplace and mounted TV, view into a den with a desk and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-IMG_1572-HDR_final.jpg"
    },
    {
      "id": "ec_9ffd47c714275c7e18a9c1fb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-bc7e-770a-82f9-2d7d32e9b488.webp",
      "image_media": {
        "alt_text": "Bedroom with bed, plant, and two framed art pieces on the wall.",
        "public_id": "01a0b67b-bc7e-770a-82f9-2d7d32e9b488",
        "storage_key": "property/6767906449167624/01a0b67b-bc7e-770a-82f9-2d7d32e9b488.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable bed, a lush green plant, and stylish abstract art. Large windows provide ample natural light.",
      "link": "false",
      "alt_text": "Bedroom with bed, plant, and two framed art pieces on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/18-IMG_1623-HDR_final.jpg"
    },
    {
      "id": "ec_983421da20082b9efa7bf6d5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-a8d5-7367-baf0-5f3cc1b5e879.webp",
      "image_media": {
        "alt_text": "Dining room with round table and four chairs, two framed artworks on wall.",
        "public_id": "01a0b67b-a8d5-7367-baf0-5f3cc1b5e879",
        "storage_key": "property/6767906449167624/01a0b67b-a8d5-7367-baf0-5f3cc1b5e879.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy meals in this charming dining room, complete with a stylish round table, four comfortable chairs, and elegant wall art. Perfect for intimate gatherings.",
      "link": "false",
      "alt_text": "Dining room with round table and four chairs, two framed artworks on wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-IMG_1606-HDR_final.jpg"
    },
    {
      "id": "ec_763428946c1bd8c6879e6ce1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-cc54-76b9-a1f1-a5dc81a17bd7.webp",
      "image_media": {
        "alt_text": "Spacious living room with a fireplace and open archway to another room.",
        "public_id": "01a0b67b-cc54-76b9-a1f1-a5dc81a17bd7",
        "storage_key": "property/6767906449167624/01a0b67b-cc54-76b9-a1f1-a5dc81a17bd7.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright and airy living space featuring a cozy fireplace, elegant chandelier, and an open design that flows into additional rooms.",
      "link": "false",
      "alt_text": "Spacious living room with a fireplace and open archway to another room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-IMG_1567-HDR_final.jpg"
    },
    {
      "id": "ec_a7bda3c06570e2213674f33a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-cc67-72c1-aee2-f4c7e9e965ae.webp",
      "image_media": {
        "alt_text": "Home office desk with chair and bookshelves near a large window.",
        "public_id": "01a0b67b-cc67-72c1-aee2-f4c7e9e965ae",
        "storage_key": "property/6767906449167624/01a0b67b-cc67-72c1-aee2-f4c7e9e965ae.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this apartment featuring a built-in desk, ample shelving, and natural light from a large window.",
      "link": "false",
      "alt_text": "Home office desk with chair and bookshelves near a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-IMG_1585-HDR_final.jpg"
    },
    {
      "id": "ec_bc2689de759cfb15a80dcebd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-dc4c-720f-bcc1-4c4ec1b8f99e.webp",
      "image_media": {
        "alt_text": "Bedroom with a large window, a queen-size bed, and modern wall art.",
        "public_id": "01a0b67b-dc4c-720f-bcc1-4c4ec1b8f99e",
        "storage_key": "property/6767906449167624/01a0b67b-dc4c-720f-bcc1-4c4ec1b8f99e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in this serene bedroom, featuring a plush queen-size bed, natural light from a large window, and elegant decor.",
      "link": "false",
      "alt_text": "Bedroom with a large window, a queen-size bed, and modern wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/17-IMG_1616_final.jpg"
    },
    {
      "id": "ec_8dd03c19e4f94cad6408dfd1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-c7d0-706d-8a5e-10285bba33f2.webp",
      "image_media": {
        "alt_text": "Bedroom with a window and a closed door.",
        "public_id": "01a0b67b-c7d0-706d-8a5e-10285bba33f2",
        "storage_key": "property/6767906449167624/01a0b67b-c7d0-706d-8a5e-10285bba33f2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a large window with blinds and a plush bed, offering a serene retreat.",
      "link": "false",
      "alt_text": "Bedroom with a window and a closed door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/21-IMG_1675_final.jpg"
    },
    {
      "id": "ec_8da28763eca6c8295f768d8a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-dbdb-72db-80a0-cf0410d58185.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "01a0b67b-dbdb-72db-80a0-cf0410d58185",
        "storage_key": "property/6767906449167624/01a0b67b-dbdb-72db-80a0-cf0410d58185.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Bright and spacious kitchen featuring white cabinetry, a double basin sink, and a full suite of appliances, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/22-IMG_1706_final.jpg"
    },
    {
      "id": "ec_872b942196125ab52947cf61",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-d822-7198-9c47-263cb15c5c43.webp",
      "image_media": {
        "alt_text": "Wynnewood Farms property sign with brick pillars and colorful flowers.",
        "public_id": "01a0b67b-d822-7198-9c47-263cb15c5c43",
        "storage_key": "property/6767906449167624/01a0b67b-d822-7198-9c47-263cb15c5c43.webp",
        "width": 1418,
        "height": 946
      },
      "title": "Community",
      "description": "Welcome to Wynnewood Farms. This image shows the property's sign with beautiful landscaping and brick pillars, representing the entrance to the community.",
      "link": "false",
      "alt_text": "Wynnewood Farms property sign with brick pillars and colorful flowers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/6WYN-Amenities-1.jpg"
    },
    {
      "id": "ec_e28b36dcc172a3a9da72b240",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-d98b-730f-bf53-a1d9fb0868b3.webp",
      "image_media": {
        "alt_text": "Building entrance with brick facade and arched windows, surrounded by lush greenery.",
        "public_id": "01a0b67b-d98b-730f-bf53-a1d9fb0868b3",
        "storage_key": "property/6767906449167624/01a0b67b-d98b-730f-bf53-a1d9fb0868b3.webp",
        "width": 1559,
        "height": 1040
      },
      "title": "Community",
      "description": "Welcome to the entrance of our beautiful community, featuring a classic brick building with charming arched windows and well-maintained landscaping.",
      "link": "false",
      "alt_text": "Building entrance with brick facade and arched windows, surrounded by lush greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/6WYN-Amenities-2.jpg"
    },
    {
      "id": "ec_6f9bbced46e1ff7a0184a0e3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-dbb3-7256-b34c-6f5a5ffdbbf1.webp",
      "image_media": {
        "alt_text": "Inviting outdoor swimming pool with lounge chairs and lush trees on a clear day.",
        "public_id": "01a0b67b-dbb3-7256-b34c-6f5a5ffdbbf1",
        "storage_key": "property/6767906449167624/01a0b67b-dbb3-7256-b34c-6f5a5ffdbbf1.webp",
        "width": 1512,
        "height": 1008
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by beautiful landscaping and comfortable lounge seating. Perfect for relaxation and fun.",
      "link": "false",
      "alt_text": "Inviting outdoor swimming pool with lounge chairs and lush trees on a clear day.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/6WYN-Amenities-3.jpg"
    },
    {
      "id": "ec_799e6adad27aff3054ee372b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-ea1e-7121-a11d-60dda944ca8b.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
        "public_id": "01a0b67b-ea1e-7121-a11d-60dda944ca8b",
        "storage_key": "property/6767906449167624/01a0b67b-ea1e-7121-a11d-60dda944ca8b.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush greenery and ample seating.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/p1099361_6WYN-Amenities-5(2)_Optimized.jpg"
    },
    {
      "id": "ec_af40788048df40089c6ae866",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-ecdb-72b6-9e21-0ba6332763f5.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical, and stationary bike.",
        "public_id": "01a0b67b-ecdb-72b6-9e21-0ba6332763f5",
        "storage_key": "property/6767906449167624/01a0b67b-ecdb-72b6-9e21-0ba6332763f5.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines like treadmills, an elliptical, and a stationary bike, providing residents with a convenient place to exercise.",
      "link": "false",
      "alt_text": "Gym with treadmills, elliptical, and stationary bike.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/6WYN-Amenities-15.jpg"
    },
    {
      "id": "ec_fdef4a4a7a138c59eb2e0292",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-ed4d-73a7-a15b-588555766df0.webp",
      "image_media": {
        "alt_text": "Fitness center with weight racks, treadmills, and elliptical machines.",
        "public_id": "01a0b67b-ed4d-73a7-a15b-588555766df0",
        "storage_key": "property/6767906449167624/01a0b67b-ed4d-73a7-a15b-588555766df0.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines and free weights.",
      "link": "false",
      "alt_text": "Fitness center with weight racks, treadmills, and elliptical machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/6WYN-Amenities-19.jpg"
    },
    {
      "id": "ec_76c3d3c9f3954c987d589dec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-eea5-73b6-ab25-5e4d5baab682.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with brick accents, garages, and balconies.",
        "public_id": "01a0b67b-eea5-73b6-ab25-5e4d5baab682",
        "storage_key": "property/6767906449167624/01a0b67b-eea5-73b6-ab25-5e4d5baab682.webp",
        "width": 1519,
        "height": 1013
      },
      "title": "Community",
      "description": "Exterior view of an apartment building showcasing brick detailing, private garages, and inviting balconies. Offers a glimpse into the community's architecture.",
      "link": "false",
      "alt_text": "Apartment building exterior with brick accents, garages, and balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/6WYN-Amenities-25.jpg"
    },
    {
      "id": "ec_7633b17d6016aadd9f4217ae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67b-f16c-71b9-9af8-c3d528485627.webp",
      "image_media": {
        "alt_text": "Covered area with car vacuum and trash can.",
        "public_id": "01a0b67b-f16c-71b9-9af8-c3d528485627",
        "storage_key": "property/6767906449167624/01a0b67b-f16c-71b9-9af8-c3d528485627.webp",
        "width": 1559,
        "height": 1040
      },
      "title": "Community",
      "description": "Convenient car vacuum and trash receptacle available for resident use in a covered area.",
      "link": "false",
      "alt_text": "Covered area with car vacuum and trash can.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/6WYN-Amenities-29.jpg"
    },
    {
      "id": "ec_555683291353d3fe6a301840",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67c-13f9-745a-a8b3-5013534cb9cc.webp",
      "image_media": {
        "alt_text": "Coffee station with Keurig machine, coffee pods, cups, and beverages.",
        "public_id": "01a0b67c-13f9-745a-a8b3-5013534cb9cc",
        "storage_key": "property/6767906449167624/01a0b67c-13f9-745a-a8b3-5013534cb9cc.webp",
        "width": 1487,
        "height": 991
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and beverages at our resident coffee station, equipped with a Keurig machine and a selection of pods and accompaniments.",
      "link": "false",
      "alt_text": "Coffee station with Keurig machine, coffee pods, cups, and beverages.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/6WYN-Amenities-40.jpg"
    },
    {
      "id": "ec_1e518a6650f6f874aa89fc05",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67c-039c-713f-9fcb-5f81c6142b36.webp",
      "image_media": {
        "alt_text": "Car vacuum station outside an apartment building.",
        "public_id": "01a0b67c-039c-713f-9fcb-5f81c6142b36",
        "storage_key": "property/6767906449167624/01a0b67c-039c-713f-9fcb-5f81c6142b36.webp",
        "width": 1641,
        "height": 1094
      },
      "title": "Community",
      "description": "Convenient car vacuum station available for residents, located outdoors near the apartment buildings.",
      "link": "false",
      "alt_text": "Car vacuum station outside an apartment building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/6WYN-Amenities-45.jpg"
    },
    {
      "id": "ec_d0a90b3e931670579ac46ec4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67c-0f47-75fe-9df8-7ab1ee7b9486.webp",
      "image_media": {
        "alt_text": "Picnic table and barbecue grill on a grassy lawn with apartment buildings in the background.",
        "public_id": "01a0b67c-0f47-75fe-9df8-7ab1ee7b9486",
        "storage_key": "property/6767906449167624/01a0b67c-0f47-75fe-9df8-7ab1ee7b9486.webp",
        "width": 1641,
        "height": 1094
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and grilling at the community picnic area, perfect for al fresco meals and gatherings with friends and family.",
      "link": "false",
      "alt_text": "Picnic table and barbecue grill on a grassy lawn with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/6WYN-Amenities-48.jpg"
    },
    {
      "id": "ec_8117e1479ae6c3be3ac585b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67c-02b4-70fe-b1d3-fa11e882b029.webp",
      "image_media": {
        "alt_text": "Spacious walk-in closet with ample shelving and hanging space.",
        "public_id": "01a0b67c-02b4-70fe-b1d3-fa11e882b029",
        "storage_key": "property/6767906449167624/01a0b67c-02b4-70fe-b1d3-fa11e882b029.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Organize your belongings in style with this generous walk-in closet, featuring custom shelving and plenty of room for all your fashion essentials.",
      "link": "false",
      "alt_text": "Spacious walk-in closet with ample shelving and hanging space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-5433 W 133rd Terrace-7_final.jpg"
    },
    {
      "id": "ec_02834375bcab77a68441dc96",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67c-1aad-71bc-9598-49e58d9173cf.webp",
      "image_media": {
        "alt_text": "Living room and kitchen with blue couch, bar stools, and modern art.",
        "public_id": "01a0b67c-1aad-71bc-9598-49e58d9173cf",
        "storage_key": "property/6767906449167624/01a0b67c-1aad-71bc-9598-49e58d9173cf.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living area seamlessly flowing into a modern kitchen with bar seating. Perfect for entertaining.",
      "link": "false",
      "alt_text": "Living room and kitchen with blue couch, bar stools, and modern art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-5433 W 133rd Terrace-6_final.jpg"
    },
    {
      "id": "ec_6c7e032339a3c0ebd8d81d55",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67c-2281-7116-a92c-3b6236a820b2.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, shower curtain, and white tiled walls.",
        "public_id": "01a0b67c-2281-7116-a92c-3b6236a820b2",
        "storage_key": "property/6767906449167624/01a0b67c-2281-7116-a92c-3b6236a820b2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax and unwind in this bright and clean bathroom, featuring a deep soaking tub and elegant shower curtain.",
      "link": "false",
      "alt_text": "Bathroom with a bathtub, shower curtain, and white tiled walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-5433 W 133rd Terrace-9_final.jpg"
    },
    {
      "id": "ec_256f863f98c7e79f93a2750b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67c-0f83-770d-93d7-0f47438eedbb.webp",
      "image_media": {
        "alt_text": "Laundry room with washer, dryer, and shelving.",
        "public_id": "01a0b67c-0f83-770d-93d7-0f47438eedbb",
        "storage_key": "property/6767906449167624/01a0b67c-0f83-770d-93d7-0f47438eedbb.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "In-unit laundry room featuring a washer and dryer, with convenient shelving and storage solutions.",
      "link": "false",
      "alt_text": "Laundry room with washer, dryer, and shelving.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-5433 W 133rd Terrace-10_final.jpg"
    },
    {
      "id": "ec_09c1bee4e071ab0f23182d49",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67c-3215-72a3-82e3-5927b0ca52d0.webp",
      "image_media": {
        "alt_text": "Living room with a sectional couch, coffee table, TV stand, and large window.",
        "public_id": "01a0b67c-3215-72a3-82e3-5927b0ca52d0",
        "storage_key": "property/6767906449167624/01a0b67c-3215-72a3-82e3-5927b0ca52d0.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A spacious living room featuring a plush sectional sofa, modern entertainment center, and a bay window offering ample natural light. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room with a sectional couch, coffee table, TV stand, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-5433 W 133rd Terrace-5_final.jpg"
    },
    {
      "id": "ec_7dabc85d473c6617facce77a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67c-3224-74bd-b3a7-aee724e13d58.webp",
      "image_media": {
        "alt_text": "Modern dining area with a marble-top table and blue chairs, adjacent to a hallway with multiple doors.",
        "public_id": "01a0b67c-3224-74bd-b3a7-aee724e13d58",
        "storage_key": "property/6767906449167624/01a0b67c-3224-74bd-b3a7-aee724e13d58.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy meals in a stylish dining area featuring a marble-top table and comfortable seating. This space offers convenient access to other parts of your home.",
      "link": "false",
      "alt_text": "Modern dining area with a marble-top table and blue chairs, adjacent to a hallway with multiple doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-5433 W 133rd Terrace-1_final.jpg"
    },
    {
      "id": "ec_cc68a7286a8cf50ca139d67a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67c-3222-7511-845e-deb69923ed74.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with double sinks and ample storage.",
        "public_id": "01a0b67c-3222-7511-845e-deb69923ed74",
        "storage_key": "property/6767906449167624/01a0b67c-3222-7511-845e-deb69923ed74.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with stone countertops, complemented by a large mirror and abundant cabinet space.",
      "link": "false",
      "alt_text": "Bathroom vanity with double sinks and ample storage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-5433 W 133rd Terrace-8_final.jpg"
    },
    {
      "id": "ec_2814af277b7bb5d386deec43",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67c-39dd-71ca-b132-d0a79d95e37a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry.",
        "public_id": "01a0b67c-39dd-71ca-b132-d0a79d95e37a",
        "storage_key": "property/6767906449167624/01a0b67c-39dd-71ca-b132-d0a79d95e37a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and updated kitchen featuring stainless steel appliances, ample cabinet space, and sleek countertops. Perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-5433 W 133rd Terrace-3_final.jpg"
    },
    {
      "id": "ec_5b91ef32e2b821aa0ab927bf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67c-2b74-77c1-b2f0-d726a3d6bc6d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and breakfast bar",
        "public_id": "01a0b67c-2b74-77c1-b2f0-d726a3d6bc6d",
        "storage_key": "property/6767906449167624/01a0b67c-2b74-77c1-b2f0-d726a3d6bc6d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Discover your ideal living space in this beautifully appointed kitchen, complete with modern appliances and a convenient breakfast bar for casual dining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and breakfast bar",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-5433 W 133rd Terrace-4_final.jpg"
    },
    {
      "id": "ec_d850c863f141ace5785b2c3c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67c-498c-73a9-9f58-7aef6437fc6a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry.",
        "public_id": "01a0b67c-498c-73a9-9f58-7aef6437fc6a",
        "storage_key": "property/6767906449167624/01a0b67c-498c-73a9-9f58-7aef6437fc6a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample counter space, and elegant white cabinetry. Perfect for all your culinary needs.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-5433 W 133rd Terrace-2_final.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e8254ebe-6047-4282-9b95-e51d1363f931",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Shack Breakfast & Lunch - Overland Park (135th)",
      "poi_type": "Restaurants",
      "poi_address": "7940 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Laid-back eatery doling out generous servings of American comfort dishes like pancakes and omelets in a quirky, sign-the-wall space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019ff6a3-f757-7343-8bd5-c60ee4b979c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-f757-7343-8bd5-c60ee4b979c4",
        "storage_key": "property/6767906449167624/019ff6a3-f757-7343-8bd5-c60ee4b979c4.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.eatatshack.com/?y_source=1_MjMzODcxNzctNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=582826780098799797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shack-breakfast--lunch---overland-park-135th",
      "poi_latitude": "38.8843095",
      "poi_longitude": "-94.6791894",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-897-2755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c757-77c9-aa9e-3287bc11121e",
        "storage_key": "property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpTwfr_bBwIcRtahfWd6dFgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_92690003-f98e-4460-8df5-73f65732e0c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Snooze, an A.M. Eatery",
      "poi_type": "Restaurants",
      "poi_address": "7012 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Vibrant, retro chain serving a seasonal menu of creative breakfast & lunch fare, plus cocktails.",
      "poi_long_description": "Vibrant, retro chain serving a seasonal menu of creative breakfast & lunch fare, plus cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019ff6a3-ff90-755f-9adb-aa40a2b26fbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-ff90-755f-9adb-aa40a2b26fbd",
        "storage_key": "property/6767906449167624/019ff6a3-ff90-755f-9adb-aa40a2b26fbd.webp",
        "width": 1280,
        "height": 793
      },
      "poi_business_url": "https://www.snoozeeatery.com/restaurant/kansas/overland-park/?utm_source=Google&utm_medium=BusinessListing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1196182886128371952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "snooze-an-am-eatery",
      "poi_latitude": "38.8841523",
      "poi_longitude": "-94.6672714",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-349-3010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c757-77c9-aa9e-3287bc11121e",
        "storage_key": "property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaXt2i_7BwIcR8EgVTv-xmRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_a4c1bee1-19d0-4e8a-9e88-ab9bf0017c98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Toastique",
      "poi_type": "Restaurants",
      "poi_address": "6445 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc993-e8d1-7420-b67b-39b41fdcbdb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-e8d1-7420-b67b-39b41fdcbdb7",
        "storage_key": "property/6767906449167624/019fc993-e8d1-7420-b67b-39b41fdcbdb7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://toastique.com/pages/overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4052123141515630879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toastique",
      "poi_latitude": "38.8832559",
      "poi_longitude": "-94.6603786",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-283-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c714-7713-a5b4-9a4788a758aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c714-7713-a5b4-9a4788a758aa",
        "storage_key": "property/6767906449167624/019fc995-c714-7713-a5b4-9a4788a758aa.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJFS4X5LvBwIcRH9ktNIcIPDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_f169a6c7-bfc8-4471-a0b8-a1c5ee92d4b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Grimaldi's Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "5601 W 135th St Suite 2240, Overland Park, KS 66224, USA",
      "poi_short_description": "Casual, Brooklyn-based pizzeria chain serving brick-oven pies & calzones, plus wine & beer.",
      "poi_long_description": "Casual, Brooklyn-based pizzeria chain serving brick-oven pies & calzones, plus wine & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc993-aa03-7738-b0ef-2c486fa52f40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-aa03-7738-b0ef-2c486fa52f40",
        "storage_key": "property/6767906449167624/019fc993-aa03-7738-b0ef-2c486fa52f40.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.grimaldispizzeria.com/locations/prairiefire/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11892796518695667969&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grimaldis-pizzeria",
      "poi_latitude": "38.8832213",
      "poi_longitude": "-94.650748",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-851-5062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c757-77c9-aa9e-3287bc11121e",
        "storage_key": "property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3bEPxvDBwIcRAYnbSmyzC6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_8bd9a87a-0e22-4fef-99c2-6ef7237881b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "The Brass Onion",
      "poi_type": "Restaurants",
      "poi_address": "5501 W 135th St, Overland Park, KS 66224, USA",
      "poi_short_description": "Mall-based spot with a lengthy menu of pub grub & comfort foods plus weekend brunch & full bar.",
      "poi_long_description": "Mall-based spot with a lengthy menu of pub grub & comfort foods plus weekend brunch & full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc993-89e5-7480-9bea-0d27fe6323cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-89e5-7480-9bea-0d27fe6323cf",
        "storage_key": "property/6767906449167624/019fc993-89e5-7480-9bea-0d27fe6323cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thebrassonion.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17421562907293316797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-brass-onion",
      "poi_latitude": "38.8832383",
      "poi_longitude": "-94.6501144",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-851-5940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c757-77c9-aa9e-3287bc11121e",
        "storage_key": "property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWeyizPDBwIcRvfZWKSnTxfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a787dadf-c00f-4e61-afa2-041d9acb7844",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "YaYas Euro Bistro in Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "7021 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Hand-tossed, oak-fired pizza & other Mediterranean eats are served at this woodsy-chic bar & eatery.",
      "poi_long_description": "Hand-tossed, oak-fired pizza & other Mediterranean eats are served at this woodsy-chic bar & eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc993-86dd-7558-847b-e8f00daab9f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-86dd-7558-847b-e8f00daab9f0",
        "storage_key": "property/6767906449167624/019fc993-86dd-7558-847b-e8f00daab9f0.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://overlandpark.yayaseurobistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9704134031630427705&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yayas-euro-bistro-in-overland-park",
      "poi_latitude": "38.8818901",
      "poi_longitude": "-94.6661847",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-345-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c757-77c9-aa9e-3287bc11121e",
        "storage_key": "property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy0tvCPTpwIcROWYcsHwCrIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "european_restaurant"
    },
    {
      "id": "custom_57482b82-6168-4266-9ea0-319c3e785926",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Rajmahal Indian Cuisine and Bar",
      "poi_type": "Restaurants",
      "poi_address": "5621 W 135th St Ste 2610, Overland Park, KS 66223, USA",
      "poi_short_description": "Contemporary locale for familiar Indian food, such as curries, tandoori dishes & biriyanis.",
      "poi_long_description": "Contemporary locale for familiar Indian food, such as curries, tandoori dishes & biriyanis.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc993-a862-77c8-be83-f81a15a1bc13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-a862-77c8-be83-f81a15a1bc13",
        "storage_key": "property/6767906449167624/019fc993-a862-77c8-be83-f81a15a1bc13.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rajindiankc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3360016778443378904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rajmahal-indian-cuisine-and-bar",
      "poi_latitude": "38.88283",
      "poi_longitude": "-94.6503674",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-645-1420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c757-77c9-aa9e-3287bc11121e",
        "storage_key": "property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI4paqX3BwIcR2FB4NnUtoS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_f952998c-6d2b-463b-a97b-20ab6db6f0ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Veritas Whiskey and Wine Grill",
      "poi_type": "Restaurants",
      "poi_address": "5621 W 135th St Ste 2620, Overland Park, KS 66223, USA",
      "poi_short_description": "Restaurant serving brunch, lunch and dinner alongside craft cocktails and a wine selection.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc993-9428-77e1-9a3e-08674a5a7e0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-9428-77e1-9a3e-08674a5a7e0e",
        "storage_key": "property/6767906449167624/019fc993-9428-77e1-9a3e-08674a5a7e0e.webp",
        "width": 926,
        "height": 806
      },
      "poi_business_url": "http://veritaskc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11216570818203659628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "veritas-whiskey-and-wine-grill",
      "poi_latitude": "38.8828245",
      "poi_longitude": "-94.6505221",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-291-0504",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c757-77c9-aa9e-3287bc11121e",
        "storage_key": "property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg8tEd_7BwIcRbK0KMbtDqZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b89a1a15-0083-4b9c-aa0f-9850cf4cc0e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "5901 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Family-friendly venue with pickleball courts and other games, plus a casual restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc994-812e-74ae-a302-850b7270f6b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-812e-74ae-a302-850b7270f6b5",
        "storage_key": "property/6767906449167624/019fc994-812e-74ae-a302-850b7270f6b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickennpickle.com/location/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3904135511973972812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chicken-n-pickle---overland-park",
      "poi_latitude": "38.8830518",
      "poi_longitude": "-94.6552102",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-703-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c757-77c9-aa9e-3287bc11121e",
        "storage_key": "property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9D8rijBwIcRTEsyKpBGLjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e6e00137-87d9-4a8b-b7e8-849eadbb9baa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Taqueria La Nueva - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "12561 Antioch Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "Casual spot specializing in authentic Mexican fare, including tacos and burritos.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-b588-7688-9887-88859f972f8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-b588-7688-9887-88859f972f8d",
        "storage_key": "property/6767906449167624/01a0b672-b588-7688-9887-88859f972f8d.webp",
        "width": 828,
        "height": 596
      },
      "poi_business_url": "http://tacoslanueva.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9992242950197903082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taqueria-la-nueva---overland-park",
      "poi_latitude": "38.9000573",
      "poi_longitude": "-94.6845757",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-766-5001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c757-77c9-aa9e-3287bc11121e",
        "storage_key": "property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8RqKoPLrwIcR6n7yowWUq4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_afa3e881-b8ac-494c-8cfd-ed73f4a93e53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Red Door Woodfired Grill",
      "poi_type": "Restaurants",
      "poi_address": "8001 W 159th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Burgers, steaks & other American classics offered in airy, industrial surrounds with patio seating.",
      "poi_long_description": "Burgers, steaks & other American classics offered in airy, industrial surrounds with patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-b63b-73bd-a1d0-697b71bd18dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-b63b-73bd-a1d0-697b71bd18dc",
        "storage_key": "property/6767906449167624/01a0b672-b63b-73bd-a1d0-697b71bd18dc.webp",
        "width": 1000,
        "height": 751
      },
      "poi_business_url": "https://reddoorgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7981812448351942793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-door-woodfired-grill",
      "poi_latitude": "38.8395569",
      "poi_longitude": "-94.6837733",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-276-3667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c757-77c9-aa9e-3287bc11121e",
        "storage_key": "property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE8S1DBvBwIcRifjO3yEYxW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_fbac4420-99a3-49fe-967f-2b2c8004acb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Ika Grill Sushi & Pan Asian",
      "poi_type": "Restaurants",
      "poi_address": "11725 Roe Ave Ste A, Leawood, KS 66211, USA",
      "poi_short_description": "Sushi, Chinese, and Korean fare with vegan and vegetarian options presented in a laid-back space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-bc82-7419-af0e-c83ac10c70af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-bc82-7419-af0e-c83ac10c70af",
        "storage_key": "property/6767906449167624/01a0b672-bc82-7419-af0e-c83ac10c70af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ikagrillks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8882791896581295035&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ika-grill-sushi--pan-asian",
      "poi_latitude": "38.91601850000001",
      "poi_longitude": "-94.6377166",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-469-8899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c757-77c9-aa9e-3287bc11121e",
        "storage_key": "property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkSzGw_LpwIcRu0tyuSoERns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_188d2620-83e1-4306-817e-057ffb6228c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "McLain's Market Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "10695 Roe Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "Open since 1945, this bakery chain serves breakfast & light lunch, plus signature cookies & cakes.",
      "poi_long_description": "Open since 1945, this bakery chain serves breakfast & light lunch, plus signature cookies & cakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-b7d9-72c4-ae94-70a2577ca5c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-b7d9-72c4-ae94-70a2577ca5c5",
        "storage_key": "property/6767906449167624/01a0b672-b7d9-72c4-ae94-70a2577ca5c5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.mclainskc.com/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8897067355057936804&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mclains-market-overland-park",
      "poi_latitude": "38.93522129999999",
      "poi_longitude": "-94.638951",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-242-8222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c757-77c9-aa9e-3287bc11121e",
        "storage_key": "property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNemdMYLpwIcRpNnz6J67eHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_d918e277-a386-49fa-bd3b-f891c8860331",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Louie's Wine Dive and Kitchen 119",
      "poi_type": "Restaurants",
      "poi_address": "6701 W 119th St, Overland Park, KS 66209, USA",
      "poi_short_description": "Comfortable destination known for locally sourced comfort food & an extensive wine list.",
      "poi_long_description": "Comfortable destination known for locally sourced comfort food & an extensive wine list.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0100a-9150-773f-893d-f145ec22347b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-9150-773f-893d-f145ec22347b",
        "storage_key": "property/6767906449167624/01a0100a-9150-773f-893d-f145ec22347b.webp",
        "width": 1024,
        "height": 682
      },
      "poi_business_url": "https://www.louieswinedive.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17363784540288348534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "louies-wine-dive-and-kitchen-119",
      "poi_latitude": "38.9123445",
      "poi_longitude": "-94.6636772",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-469-4177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0100a-e1d3-741d-977b-3574563e61c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0100a-e1d3-741d-977b-3574563e61c7",
        "storage_key": "property/6767906449167624/01a0100a-e1d3-741d-977b-3574563e61c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGUqh8BTqwIcRdnFOyAqO-PA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "custom_293a7b40-c88b-4556-8ca1-542668f11125",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Urban Egg",
      "poi_type": "Restaurants",
      "poi_address": "4921 W 119th St, Overland Park, KS 66209, USA",
      "poi_short_description": "Popular all-day breakfast joint offering eggs benedict & pancakes with locally-sourced ingredients.",
      "poi_long_description": "Popular all-day breakfast joint offering eggs benedict & pancakes with locally-sourced ingredients.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-b842-772a-8c3e-32504df90ee3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-b842-772a-8c3e-32504df90ee3",
        "storage_key": "property/6767906449167624/01a0b672-b842-772a-8c3e-32504df90ee3.webp",
        "width": 1280,
        "height": 826
      },
      "poi_business_url": "https://www.urbanegg.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1769714533237697318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urban-egg",
      "poi_latitude": "38.9117497",
      "poi_longitude": "-94.6421742",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-586-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c757-77c9-aa9e-3287bc11121e",
        "storage_key": "property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjWbBV6jpwIcRJqt62_1Jjxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_d5c32bbb-7b86-4909-90ab-b845695ba2aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "QuikTrip",
      "poi_type": "Transportation & Transit",
      "poi_address": "11100 Antioch Rd, Overland Park, KS 66210, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc993-dc6c-7297-93b7-21ccaafb19d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-dc6c-7297-93b7-21ccaafb19d1",
        "storage_key": "property/6767906449167624/019fc993-dc6c-7297-93b7-21ccaafb19d1.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/ks/overland-park/11100-antioch-rd?utm_source=gmb&utm_medium=yext&y_source=1_MTAyMDQ4ODA0Ny03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10359270060311123864&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "38.926753",
      "poi_longitude": "-94.6867645",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-693-9776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7bf-721f-ba75-26dbba28abc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7bf-721f-ba75-26dbba28abc9",
        "storage_key": "property/6767906449167624/019fc995-c7bf-721f-ba75-26dbba28abc9.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJaQqUcPjqwIcRmBcv7TuFw48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_ddc4382c-a876-4f38-821b-ae9b0b1fa557",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Hen House Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6900 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Casual market, deli and supermarket with fresh produce and a large meat section along with a florist, a bakery, a cafe, prepared foods and bagels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019ff6a4-250d-70cf-81a2-6c1465a42d61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-250d-70cf-81a2-6c1465a42d61",
        "storage_key": "property/6767906449167624/019ff6a4-250d-70cf-81a2-6c1465a42d61.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "http://henhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3407519095472349622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hen-house-market",
      "poi_latitude": "38.8856924",
      "poi_longitude": "-94.6657055",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-685-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7e2-721b-9eac-afb2ccfc068d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7e2-721b-9eac-afb2ccfc068d",
        "storage_key": "property/6767906449167624/019fc995-c7e2-721b-9eac-afb2ccfc068d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIbLSX93BwIcRtmH9QpDwSS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_fb48c3ec-2f54-44da-8cdd-d5c5a2e5c479",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "McKeever's Price Chopper",
      "poi_type": "Shopping & Retail",
      "poi_address": "11700 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "Chain shop for groceries and baked goods, plus a selection of deli favorites and prepared foods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0100a-9884-718f-9257-b3418a78b6a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-9884-718f-9257-b3418a78b6a6",
        "storage_key": "property/6767906449167624/01a0100a-9884-718f-9257-b3418a78b6a6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mypricechopper.com/store-details?storeId=96",
      "poi_directions_map_url": "https://maps.google.com/?cid=2000385917123995709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckeevers-price-chopper",
      "poi_latitude": "38.886436",
      "poi_longitude": "-94.721598",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-685-8666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7e2-721b-9eac-afb2ccfc068d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7e2-721b-9eac-afb2ccfc068d",
        "storage_key": "property/6767906449167624/019fc995-c7e2-721b-9eac-afb2ccfc068d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ11oGoqDBwIcRPajeo2TMwhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_45bf4192-aac8-4a12-aa0d-cb28ddeedc77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "5001 W 135th St, Leawood, KS 66224, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-bdad-728b-a66c-3fc03b9148d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-bdad-728b-a66c-3fc03b9148d9",
        "storage_key": "property/6767906449167624/01a0b672-bdad-728b-a66c-3fc03b9148d9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/leawood-ks-pharmacies/5001-w-135th-st-leawood-ks-66224/storeid=8237?WT.mc_id=LS_GOOGLE_FS_8237",
      "poi_directions_map_url": "https://maps.google.com/?cid=4909360715823320469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "38.8832236",
      "poi_longitude": "-94.6451157",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-851-9903",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-8d7636d013d2",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcXq23vfBwIcRlQ3oZI-NIUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_0b22e363-e094-4cb2-919b-f008d380d2e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1701 W 133rd St, Kansas City, MO 64145, USA",
      "poi_short_description": "Retail department store (part of a chain) selling electronics, toys, furniture, clothes and home goods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc993-e8e5-773c-994b-c40d9bc47b07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-e8e5-773c-994b-c40d9bc47b07",
        "storage_key": "property/6767906449167624/019fc993-e8e5-773c-994b-c40d9bc47b07.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2955-kansas-city-mo/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=8154518660480768764&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "38.8851966",
      "poi_longitude": "-94.6052627",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-942-3847",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7ca-7128-9486-9687ff2dc3bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7ca-7128-9486-9687ff2dc3bc",
        "storage_key": "property/6767906449167624/019fc995-c7ca-7128-9486-9687ff2dc3bc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJR8ji6GLCwIcR_BpAaISrKnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_d8d3c6d7-574b-465d-a0ec-cf6206461c97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Deer Creek Woods",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Overland Park, KS 66213, USA",
      "poi_short_description": "Business center with shopping and a variety of dining options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-c209-7305-a783-4969d677c11a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-c209-7305-a783-4969d677c11a",
        "storage_key": "property/6767906449167624/01a0b672-c209-7305-a783-4969d677c11a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8254317333613220667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deer-creek-woods",
      "poi_latitude": "38.884907",
      "poi_longitude": "-94.6706907",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-8d7636d013d2",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk87-ptzBwIcRO5NdteE5jXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "custom_4ec21bfc-86b6-426d-9e8c-8aa2fcbd403e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Prairiefire",
      "poi_type": "Shopping & Retail",
      "poi_address": "5661 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Unique entertainment venue with a shopping mall, museum exhibits & a self-guided wetlands trail.",
      "poi_long_description": "Unique entertainment venue with a shopping mall, museum exhibits & a self-guided wetlands trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-c0d2-77be-ae42-f5565f0bc4c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-c0d2-77be-ae42-f5565f0bc4c6",
        "storage_key": "property/6767906449167624/01a0b672-c0d2-77be-ae42-f5565f0bc4c6.webp",
        "width": 1280,
        "height": 807
      },
      "poi_business_url": "http://prairiefireop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10467907726029435577&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prairiefire",
      "poi_latitude": "38.8827368",
      "poi_longitude": "-94.6507027",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-338-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7ca-7128-9486-9687ff2dc3bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7ca-7128-9486-9687ff2dc3bc",
        "storage_key": "property/6767906449167624/019fc995-c7ca-7128-9486-9687ff2dc3bc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMcRmTvDBwIcRuTKNj516RZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_87b47253-538d-423c-81dc-ddd08ab7dc77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Corbin Park",
      "poi_type": "Shopping & Retail",
      "poi_address": "6917 W 135th St #29, Overland Park, KS 66223, USA",
      "poi_short_description": "Upscale shopping mall offering a department store, an organic grocer, furnishings & restaurants.",
      "poi_long_description": "Upscale shopping mall offering a department store, an organic grocer, furnishings & restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-c325-70ed-b238-882ed8852f40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-c325-70ed-b238-882ed8852f40",
        "storage_key": "property/6767906449167624/01a0b672-c325-70ed-b238-882ed8852f40.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.corbinparkop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5069566010625269083&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corbin-park",
      "poi_latitude": "38.88257",
      "poi_longitude": "-94.6630357",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-499-1926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7ca-7128-9486-9687ff2dc3bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7ca-7128-9486-9687ff2dc3bc",
        "storage_key": "property/6767906449167624/019fc995-c7ca-7128-9486-9687ff2dc3bc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJK3wCC-nBwIcRW522TG23WkY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_226c7788-3e3d-4084-aab8-5fe08d791998",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "8300 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0100a-9ae5-7188-a5ca-dae50c48afa3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-9ae5-7188-a5ca-dae50c48afa3",
        "storage_key": "property/6767906449167624/01a0100a-9ae5-7188-a5ca-dae50c48afa3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/4707-overland-park-ks",
      "poi_directions_map_url": "https://maps.google.com/?cid=13205436472745682803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "38.8863478",
      "poi_longitude": "-94.6830744",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-402-1405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7ca-7128-9486-9687ff2dc3bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7ca-7128-9486-9687ff2dc3bc",
        "storage_key": "property/6767906449167624/019fc995-c7ca-7128-9486-9687ff2dc3bc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJtbHmBtLBwIcRc2f-rYEiQ7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_5602cf89-bf8d-4739-a290-094a7cdf4e81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "12221 Blue Valley Pkwy, Overland Park, KS 66213, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-c2cc-762a-9736-55aa65afa341.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-c2cc-762a-9736-55aa65afa341",
        "storage_key": "property/6767906449167624/01a0b672-c2cc-762a-9736-55aa65afa341.webp",
        "width": 1280,
        "height": 518
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/overland-park-KS-369.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=12181420978670501186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "38.9065093",
      "poi_longitude": "-94.6707763",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-217-2050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7ca-7128-9486-9687ff2dc3bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7ca-7128-9486-9687ff2dc3bc",
        "storage_key": "property/6767906449167624/019fc995-c7ca-7128-9486-9687ff2dc3bc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJg8cveG7qwIcRQn0lFdcZDak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_d60a0591-ab41-48a3-b05d-fbe3066ef465",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Overland Trail Elementary School",
      "poi_type": "Education",
      "poi_address": "6225 W 133rd St, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc994-25d1-7284-b162-abcf9abdd136.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-25d1-7284-b162-abcf9abdd136",
        "storage_key": "property/6767906449167624/019fc994-25d1-7284-b162-abcf9abdd136.webp",
        "width": 1280,
        "height": 861
      },
      "poi_business_url": "https://www.bluevalleyk12.org/OTE",
      "poi_directions_map_url": "https://maps.google.com/?cid=2244344860322751896&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-trail-elementary-school",
      "poi_latitude": "38.88582210000001",
      "poi_longitude": "-94.6575254",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-239-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-92368c39738d",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJy1sTYGPwIcRmOUCacKDJR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_913d77fb-0e4e-47f9-80ba-949d5114dc41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Overland Trail Middle School",
      "poi_type": "Education",
      "poi_address": "6201 W 133rd St, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc994-1823-76c8-91ef-61d0116bb566.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-1823-76c8-91ef-61d0116bb566",
        "storage_key": "property/6767906449167624/019fc994-1823-76c8-91ef-61d0116bb566.webp",
        "width": 1280,
        "height": 543
      },
      "poi_business_url": "https://www.bluevalleyk12.org/OTM",
      "poi_directions_map_url": "https://maps.google.com/?cid=15599445353126869038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-trail-middle-school",
      "poi_latitude": "38.8855363",
      "poi_longitude": "-94.6545605",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-239-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-92368c39738d",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJy1sTYGPwIcRLrg-NuZcfNg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6870a137-bdac-4128-9acf-3202a4620436",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Blue Valley North High School",
      "poi_type": "Education",
      "poi_address": "12200 Lamar Ave, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019ff6a4-6dce-7089-8642-ca3fcb8a2095.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-6dce-7089-8642-ca3fcb8a2095",
        "storage_key": "property/6767906449167624/019ff6a4-6dce-7089-8642-ca3fcb8a2095.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bluevalleyk12.org/bvn",
      "poi_directions_map_url": "https://maps.google.com/?cid=15101532817909822492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-valley-north-high-school",
      "poi_latitude": "38.9068618",
      "poi_longitude": "-94.6604547",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-239-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-92368c39738d",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoROKIBLqwIcRHDRrJxZsk9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_61413b09-8e28-4187-bfed-68f4261a4cfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Valley Park Elementary School",
      "poi_type": "Education",
      "poi_address": "12301 Lamar Ave, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bluevalleyk12.org/vpe",
      "poi_directions_map_url": "https://maps.google.com/?cid=9356314748604894902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-park-elementary-school",
      "poi_latitude": "38.9051188",
      "poi_longitude": "-94.6573811",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-239-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-92368c39738d",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM_W9fjHqwIcRts5XJbFO2IE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_36df26fe-974c-4809-ba03-53b5371cb627",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Mission Trail Elementary School",
      "poi_type": "Education",
      "poi_address": "13200 Mission Rd, Leawood, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bluevalleyk12.org/mte",
      "poi_directions_map_url": "https://maps.google.com/?cid=4659330755270168331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-trail-elementary-school",
      "poi_latitude": "38.8876772",
      "poi_longitude": "-94.6315655",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-239-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-92368c39738d",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf36aOADDwIcRC0_uvqJEqUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_fa8f8941-7167-4d88-95c9-fb5155976aba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "All Around Child",
      "poi_type": "Education",
      "poi_address": "9205 W 133rd St, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-c8f8-768b-af75-d6bdde6d8b26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-c8f8-768b-af75-d6bdde6d8b26",
        "storage_key": "property/6767906449167624/01a0b672-c8f8-768b-af75-d6bdde6d8b26.webp",
        "width": 1022,
        "height": 776
      },
      "poi_business_url": "http://allaroundchild.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11447569397547624728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "all-around-child",
      "poi_latitude": "38.8857243",
      "poi_longitude": "-94.6942747",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-239-9798",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-92368c39738d",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJORsQAy_AwIcRGGl1Grfv3Z4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_bc94e61d-7b77-45ab-b1ef-cce0cde03209",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Primrose School of Overland Park",
      "poi_type": "Education",
      "poi_address": "12100 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "Warm-looking daycare with a curriculum, clean facilities and educational programs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-c916-7120-9618-76fb7c824617.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-c916-7120-9618-76fb7c824617",
        "storage_key": "property/6767906449167624/01a0b672-c916-7120-9618-76fb7c824617.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.primroseschools.com/schools/overland-park/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4306267260814237208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-overland-park",
      "poi_latitude": "38.8862853",
      "poi_longitude": "-94.725953",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-400-2435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-92368c39738d",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb1EZGAfAwIcRGB66FELvwjs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_d966d26e-e52d-4a4c-bbdd-b5101bf487a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Nativity Parish School",
      "poi_type": "Education",
      "poi_address": "3700 W 119th St #1085, Leawood, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc994-31f7-7291-a3d3-6b1735cdad5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-31f7-7291-a3d3-6b1735cdad5c",
        "storage_key": "property/6767906449167624/019fc994-31f7-7291-a3d3-6b1735cdad5c.webp",
        "width": 1075,
        "height": 520
      },
      "poi_business_url": "http://www.nativityparishschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4522078707558512782&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nativity-parish-school",
      "poi_latitude": "38.91402",
      "poi_longitude": "-94.629407",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-338-4330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-92368c39738d",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk75-EuzpwIcRjvhhIqCmwT4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_9e65b70a-11f0-43d0-83bb-2f4bed5aa536",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc98f-7713-77fb-a2ab-26c36f49a78e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98f-7713-77fb-a2ab-26c36f49a78e",
        "storage_key": "property/6767906449167624/019fc98f-7713-77fb-a2ab-26c36f49a78e.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-92368c39738d",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1accedd0-d074-49c6-9c85-d28414c376ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Overland Christian School",
      "poi_type": "Education",
      "poi_address": "7016 W 74th St, Overland Park, KS 66204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://overlandchristian.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15224425969390430137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-christian-school",
      "poi_latitude": "38.9955097",
      "poi_longitude": "-94.6659802",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 913-948-9994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-92368c39738d",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG6YXNGvswIcRuae_tsEGSNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_066f59e9-d29a-4701-b67f-a4011fb5fa93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Museum at Prairiefire",
      "poi_type": "Entertainment",
      "poi_address": "5801 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_long_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc990-a3d4-77dc-80a1-ca73cf56c864.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc990-a3d4-77dc-80a1-ca73cf56c864",
        "storage_key": "property/6767906449167624/019fc990-a3d4-77dc-80a1-ca73cf56c864.webp",
        "width": 1170,
        "height": 797
      },
      "poi_business_url": "https://www.visitthemap.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9011883457387750483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-at-prairiefire",
      "poi_latitude": "38.8819446",
      "poi_longitude": "-94.6520905",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-333-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7bd-746e-922b-011726f4642d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7bd-746e-922b-011726f4642d",
        "storage_key": "property/6767906449167624/019fc995-c7bd-746e-922b-011726f4642d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdDvHPHBwIcRU-TQ6kGkEH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6a83a05a-d500-4aed-bc68-71605bf77375",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "AMC Prairiefire 17",
      "poi_type": "Entertainment",
      "poi_address": "5724 W 136th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Comfortable entertainment venue featuring a full menu alongside movie screenings of new releases.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc994-3fbc-77ba-926d-4eafd3bc5982.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-3fbc-77ba-926d-4eafd3bc5982",
        "storage_key": "property/6767906449167624/019fc994-3fbc-77ba-926d-4eafd3bc5982.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-prairiefire-17?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3727223515720771879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-prairiefire-17",
      "poi_latitude": "38.8826984",
      "poi_longitude": "-94.651566",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-553-3075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7d9-7757-b2e6-ca3cb2fd13a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7d9-7757-b2e6-ca3cb2fd13a9",
        "storage_key": "property/6767906449167624/019fc995-c7d9-7757-b2e6-ca3cb2fd13a9.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7fXu5_DBwIcRJ-kENQrCuTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_f5e1c0ec-9d84-4bf3-b4bf-7a7d4b3aa688",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Pinstripes",
      "poi_type": "Restaurants",
      "poi_address": "13500 Nall Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "Italian-American fare, bowling & bocce in a sprawling space with indoor & outdoor seating & a bar.",
      "poi_long_description": "Italian-American fare, bowling & bocce in a sprawling space with indoor & outdoor seating & a bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc993-86ca-736e-928d-94a08a72bec6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-86ca-736e-928d-94a08a72bec6",
        "storage_key": "property/6767906449167624/019fc993-86ca-736e-928d-94a08a72bec6.webp",
        "width": 839,
        "height": 623
      },
      "poi_business_url": "https://pinstripes.com/?utm_source=local&utm_medium=organic&utm_content=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5277492073553538943&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinstripes",
      "poi_latitude": "38.8828273",
      "poi_longitude": "-94.6497866",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-681-2255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c757-77c9-aa9e-3287bc11121e",
        "storage_key": "property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUQ-iOPfBwIcRfy8ZXRRrPUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d879fd7b-a4b5-4a19-928e-8536b748846d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Topgolf Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "10611 Nall Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc994-59cb-76dd-8997-b1149a5bb931.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-59cb-76dd-8997-b1149a5bb931",
        "storage_key": "property/6767906449167624/019fc994-59cb-76dd-8997-b1149a5bb931.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "https://topgolf.com/us/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4737452325202402593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-overland-park",
      "poi_latitude": "38.9364597",
      "poi_longitude": "-94.64818",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-562-9713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c757-77c9-aa9e-3287bc11121e",
        "storage_key": "property/6767906449167624/019fc995-c757-77c9-aa9e-3287bc11121e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJibz1RyvqwIcRIZ0JKMrPvkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_054aa61a-6a97-4a9e-ad46-517cbbed9bfe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Nerman Museum of Contemporary Art",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_long_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc98f-ca32-75ad-adec-69d6e24da64b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98f-ca32-75ad-adec-69d6e24da64b",
        "storage_key": "property/6767906449167624/019fc98f-ca32-75ad-adec-69d6e24da64b.webp",
        "width": 1080,
        "height": 830
      },
      "poi_business_url": "http://www.nermanmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4973184191241098516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nerman-museum-of-contemporary-art",
      "poi_latitude": "38.924852",
      "poi_longitude": "-94.726824",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-469-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7bd-746e-922b-011726f4642d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7bd-746e-922b-011726f4642d",
        "storage_key": "property/6767906449167624/019fc995-c7bd-746e-922b-011726f4642d.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRFJWDQaxMBEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_c5048395-e4f3-410f-be79-29b974114c81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "iFLY Indoor Skydiving - Kansas City",
      "poi_type": "Health and Wellness",
      "poi_address": "10975 Metcalf Ave, Overland Park, KS 66210, USA",
      "poi_short_description": "State-of-the-art wind tunnels are used for indoor skydiving at this family-friendly entertainment center.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019ff6a4-3f5b-716e-9049-2c9c456f5ec5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-3f5b-716e-9049-2c9c456f5ec5",
        "storage_key": "property/6767906449167624/019ff6a4-3f5b-716e-9049-2c9c456f5ec5.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.iflyworld.com/kansas-city/?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2133132905847574967&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ifly-indoor-skydiving---kansas-city",
      "poi_latitude": "38.93024",
      "poi_longitude": "-94.666288",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-305-4359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-8d7636d013d2",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2wSq70nqwIcRt9G9dxNpmh0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_6256c927-1e57-4049-acca-6b66c4d4e5bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Andretti Indoor Karting & Games Overland Park",
      "poi_type": "Entertainment",
      "poi_address": "11610 Nall Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0100a-b17a-76f1-aa95-a4fc758aed82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-b17a-76f1-aa95-a4fc758aed82",
        "storage_key": "property/6767906449167624/01a0100a-b17a-76f1-aa95-a4fc758aed82.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://andrettikarting.com/overlandpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=12146707873347930037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andretti-indoor-karting--games-overland-park",
      "poi_latitude": "38.91818490000001",
      "poi_longitude": "-94.6498735",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-937-4201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-8d7636d013d2",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1VUXQDrwIcRtQdYbXTGkag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_4fefc005-7627-4dc6-b151-1ef957b04db9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Deanna Rose Children's Farmstead",
      "poi_type": "Entertainment",
      "poi_address": "13800 Switzer Rd, Overland Park, KS 66221, USA",
      "poi_short_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_long_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc994-4a79-706f-994a-03ddca88c36f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-4a79-706f-994a-03ddca88c36f",
        "storage_key": "property/6767906449167624/019fc994-4a79-706f-994a-03ddca88c36f.webp",
        "width": 640,
        "height": 349
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/deanna-rose-childrens-farmstead/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7835830010939554497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deanna-rose-childrens-farmstead",
      "poi_latitude": "38.877729",
      "poi_longitude": "-94.703345",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-897-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-8d7636d013d2",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6IUwjvAwIcRwbplAuF1vmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_194c8b15-6d57-49f2-808e-41136278ef68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Overland Park Arboretum & Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8909 W 179th St, Overland Park, KS 66013, USA",
      "poi_short_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_long_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc992-661e-7017-b4b0-6ec496a473fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-661e-7017-b4b0-6ec496a473fd",
        "storage_key": "property/6767906449167624/019fc992-661e-7017-b4b0-6ec496a473fd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/recreation-fun/arboretum-botanical-gardens/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8713039177416778041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-arboretum--botanical-gardens",
      "poi_latitude": "38.8033925",
      "poi_longitude": "-94.6891159",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-685-3604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-8d7636d013d2",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6csjvynHwIcROSH92_fu6ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_37cf89a0-21f4-49b3-9cfa-384532f02c4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Saint Luke's South Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "12300 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-0fd0-77be-8d6a-3ae9a9a4f754.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-0fd0-77be-8d6a-3ae9a9a4f754",
        "storage_key": "property/6767906449167624/019fc995-0fd0-77be-8d6a-3ae9a9a4f754.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-south-hospital?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=8966224544508452770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-south-hospital",
      "poi_latitude": "38.9041982",
      "poi_longitude": "-94.6695167",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-317-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-cdb1-7603-adf2-1b856d80f4d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-cdb1-7603-adf2-1b856d80f4d0",
        "storage_key": "property/6767906449167624/019fc995-cdb1-7603-adf2-1b856d80f4d0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkT2aF3LqwIcRop_Q17dtbnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_6ae68393-8fd1-4b2a-bfaf-c405eb3a72f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Overland Park Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10500 Quivira Rd, Overland Park, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc994-57db-74a7-9692-6244eca83750.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-57db-74a7-9692-6244eca83750",
        "storage_key": "property/6767906449167624/019fc994-57db-74a7-9692-6244eca83750.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/overland-park-regional-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13555409796355494155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-regional-medical-center",
      "poi_latitude": "38.9376197",
      "poi_longitude": "-94.7261812",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-541-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-cdb1-7603-adf2-1b856d80f4d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-cdb1-7603-adf2-1b856d80f4d0",
        "storage_key": "property/6767906449167624/019fc995-cdb1-7603-adf2-1b856d80f4d0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cFCWJzAwIcRC5Ge4GN9Hrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e8f54064-b407-4abd-bb96-0adfe4cc07d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "AdventHealth Centra Care Overland Park",
      "poi_type": "Health and Wellness",
      "poi_address": "9099 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc994-6060-77d5-bc1c-d2226c57b281.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-6060-77d5-bc1c-d2226c57b281",
        "storage_key": "property/6767906449167624/019fc994-6060-77d5-bc1c-d2226c57b281.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://centracare.adventhealth.com/urgent-care/overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16421499770594357393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventhealth-centra-care-overland-park",
      "poi_latitude": "38.8832467",
      "poi_longitude": "-94.6909065",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-549-4242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-8d7636d013d2",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwRwCDLAwIcRkXBvWQnj5OM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_8650ef1f-a357-4c7c-a966-dc1dc8ceb59c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Spira Care Overland Park",
      "poi_type": "Health and Wellness",
      "poi_address": "7341 W 133rd St, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-ccde-75e7-8238-81ed1f9db0ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-ccde-75e7-8238-81ed1f9db0ce",
        "storage_key": "property/6767906449167624/01a0b672-ccde-75e7-8238-81ed1f9db0ce.webp",
        "width": 1280,
        "height": 874
      },
      "poi_business_url": "https://www.spiracare.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-listing&utm_content=overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10149369953486934262&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spira-care-overland-park",
      "poi_latitude": "38.8865415",
      "poi_longitude": "-94.6712343",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-297-7472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-8d7636d013d2",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTc75m4fBwIcR9pCc8zLO2Yw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_97abc632-2ac6-47d4-ad0f-20e6bdfae8e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Hy-Vee Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "8900 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0100a-b862-77be-bb73-a680b415ffc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-b862-77be-bb73-a680b415ffc6",
        "storage_key": "property/6767906449167624/01a0100a-b862-77be-bb73-a680b415ffc6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.hy-vee.com/my-pharmacy/pharmacy-finder/overland-park-2-8900-w-135-st-overland-park-ks/1509?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=10592957387033179426&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hy-vee-pharmacy",
      "poi_latitude": "38.8853994",
      "poi_longitude": "-94.6884219",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-685-3299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7dd-7515-aade-f97352ae24ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7dd-7515-aade-f97352ae24ec",
        "storage_key": "property/6767906449167624/019fc995-c7dd-7515-aade-f97352ae24ec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____BC3AwIcRInX2np6-AZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_256f1707-e224-49da-880f-9901169456f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "9500 Antioch Rd, Overland Park, KS 66212, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-cd4c-70c7-aab3-af30bb90b74d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-cd4c-70c7-aab3-af30bb90b74d",
        "storage_key": "property/6767906449167624/01a0b672-cd4c-70c7-aab3-af30bb90b74d.webp",
        "width": 1280,
        "height": 900
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-9500+antioch+rd-overland+park-ks-66212/id=11370",
      "poi_directions_map_url": "https://maps.google.com/?cid=2757867379827177112&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "38.95620100000001",
      "poi_longitude": "-94.6869671",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-381-0138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-8d7636d013d2",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1V7VyArrwIcRmHY8KMXpRSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_9514b58e-5269-4f1e-a957-7a135ec749ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "6800 138th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Upscale gym with a spa, an indoor and an outdoor pool, plus a hair salon.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc994-7dcf-77dc-9de5-0d846f89fa7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-7dcf-77dc-9de5-0d846f89fa7e",
        "storage_key": "property/6767906449167624/019fc994-7dcf-77dc-9de5-0d846f89fa7e.webp",
        "width": 1200,
        "height": 627
      },
      "poi_business_url": "https://www.lifetime.life/locations/ks/overland-park?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=6007822183813280658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "38.8789466",
      "poi_longitude": "-94.6645722",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-239-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-8d7636d013d2",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeyRfIerBwIcRkvPmA3ISYFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_7806c726-187f-424d-9dea-9a808caa544b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "11320 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "Chain gym with tanning and spa facilities, as well as hydroloungers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc991-b754-751d-8d64-63c20bc97e60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-b754-751d-8d64-63c20bc97e60",
        "storage_key": "property/6767906449167624/019fc991-b754-751d-8d64-63c20bc97e60.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/overland-park-135th-st-ks?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1396585211980257129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.88575820000001",
      "poi_longitude": "-94.71868700000002",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-402-0999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-8d7636d013d2",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu_puNwXAwIcRaZel0tmqYRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ec40d53b-dd19-4062-93d5-33580275df5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9538 Nall Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "Heart-rate training for all fitness levels in studios with heart-rate monitors, treadmills and rowing machines.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0100a-c62b-704e-9fd7-76737a2d2ef9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-c62b-704e-9fd7-76737a2d2ef9",
        "storage_key": "property/6767906449167624/01a0100a-c62b-704e-9fd7-76737a2d2ef9.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/overland-park-kansas-0514?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=4615430848133583991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "38.9552057",
      "poi_longitude": "-94.6511832",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-440-0010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-8d7636d013d2",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU_ZUy93rwIcRd9RhHOdNDUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a95c964e-d1e1-4eb4-a023-6d0f16734f0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Gezer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13251 Mission Rd, Leawood, KS 66209, USA",
      "poi_short_description": "Laid-back park with paved walking trails, a playground and a sandpit.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc994-879f-773a-9ac6-35f4cb0e5254.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-879f-773a-9ac6-35f4cb0e5254",
        "storage_key": "property/6767906449167624/019fc994-879f-773a-9ac6-35f4cb0e5254.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://www.leawood.org/facilities/facility/details/Gezer-Park-12",
      "poi_directions_map_url": "https://maps.google.com/?cid=6432708722736127620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gezer-park",
      "poi_latitude": "38.8866337",
      "poi_longitude": "-94.6280323",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-663-9151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-cdb0-7199-850a-4fece608df48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-cdb0-7199-850a-4fece608df48",
        "storage_key": "property/6767906449167624/019fc995-cdb0-7199-850a-4fece608df48.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt2u6kw3CwIcRhF4-WoCSRVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9dd581f9-830a-4039-9d5c-c15e91af31ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Yilan Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12601 Nall Ave, Leawood, KS 66209, USA",
      "poi_short_description": "Family-friendly park with a playground, picnic tables, walking trails, and shelters.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019ff6a4-6b78-76dd-8923-9c8fe009cdea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-6b78-76dd-8923-9c8fe009cdea",
        "storage_key": "property/6767906449167624/019ff6a4-6b78-76dd-8923-9c8fe009cdea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.leawood.org/facilities/facility/details/ILan-Park-11",
      "poi_directions_map_url": "https://maps.google.com/?cid=5345098373116711597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yilan-park",
      "poi_latitude": "38.9010273",
      "poi_longitude": "-94.6478844",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-339-6700 ext. 151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-cdb0-7199-850a-4fece608df48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-cdb0-7199-850a-4fece608df48",
        "storage_key": "property/6767906449167624/019fc995-cdb0-7199-850a-4fece608df48.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKfoEzQPqwIcRrdIjm6aaLUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1b9c7d9e-95fe-4f4f-a63c-8f0356aa2c9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Tomahawk Creek Bike Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11400 Tomahawk Creek Pkwy, Leawood, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-d318-734c-b8e2-feec646529b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-d318-734c-b8e2-feec646529b2",
        "storage_key": "property/6767906449167624/01a0b672-d318-734c-b8e2-feec646529b2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16638672646820377085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tomahawk-creek-bike-park",
      "poi_latitude": "38.9227132",
      "poi_longitude": "-94.6265485",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-cdb0-7199-850a-4fece608df48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-cdb0-7199-850a-4fece608df48",
        "storage_key": "property/6767906449167624/019fc995-cdb0-7199-850a-4fece608df48.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZQaDf5bpwIcR_bG8551w6OY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f4cdb0ce-0afc-4046-be53-016f81d9726b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Scheels Overland Park Soccer Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13700 Switzer Rd, Overland Park, KS 66221, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc994-e02b-707d-872a-7d622be19be6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-e02b-707d-872a-7d622be19be6",
        "storage_key": "property/6767906449167624/019fc994-e02b-707d-872a-7d622be19be6.webp",
        "width": 1280,
        "height": 894
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/soccer-complex/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3095772957620985062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scheels-overland-park-soccer-complex",
      "poi_latitude": "38.8802627",
      "poi_longitude": "-94.7045196",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-685-1512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-8d7636d013d2",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG9T6_zzAwIcR5lxCVBpl9io",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_94108a15-d805-44ae-ad49-00cccb40cc9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Tomahawk Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3951 W 119th St, Leawood, KS 66209, USA",
      "poi_short_description": "Clean green space featuring swings, slides and trails, along with a baseball field.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019ff6a4-72c6-71d9-a093-89bef254884e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-72c6-71d9-a093-89bef254884e",
        "storage_key": "property/6767906449167624/019ff6a4-72c6-71d9-a093-89bef254884e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.leawood.org/facilities/facility/details/Tomahawk-Park-8",
      "poi_directions_map_url": "https://maps.google.com/?cid=18086110426331874286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tomahawk-park",
      "poi_latitude": "38.9106595",
      "poi_longitude": "-94.6336445",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-339-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-cdb0-7199-850a-4fece608df48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-cdb0-7199-850a-4fece608df48",
        "storage_key": "property/6767906449167624/019fc995-cdb0-7199-850a-4fece608df48.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJTd8nBu7pwIcR7gMAwpvF_vo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_095e59ca-4d60-4c9f-95e4-58384009c6bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Hawthorne Valley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12300 Roe Ave, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-d20f-706f-a0ca-efe23ddd1f69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-d20f-706f-a0ca-efe23ddd1f69",
        "storage_key": "property/6767906449167624/01a0b672-d20f-706f-a0ca-efe23ddd1f69.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/things-to-see-and-do/parks/list-of-city-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7353288394318201191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hawthorne-valley-park",
      "poi_latitude": "38.905546",
      "poi_longitude": "-94.641633",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-cdb0-7199-850a-4fece608df48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-cdb0-7199-850a-4fece608df48",
        "storage_key": "property/6767906449167624/019fc995-cdb0-7199-850a-4fece608df48.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__gc2_npwIcRZ8FW0tUgDGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_dd2f8100-ed94-41d1-9c22-5ff00d4f1d51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Beth Torah Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12521 Lamar Ave, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-d529-729f-b49d-f3fba6436e99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-d529-729f-b49d-f3fba6436e99",
        "storage_key": "property/6767906449167624/01a0b672-d529-729f-b49d-f3fba6436e99.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10316960347369686280&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beth-torah-park",
      "poi_latitude": "38.899915",
      "poi_longitude": "-94.6563684",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-895-6156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-cdb0-7199-850a-4fece608df48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-cdb0-7199-850a-4fece608df48",
        "storage_key": "property/6767906449167624/019fc995-cdb0-7199-850a-4fece608df48.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJj7mrtgjqwIcRCMXCOsY0LY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_faa04c6e-95a7-4771-abf9-9497b0eb0c3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Nall Hills Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5501 Indian Creek Dr, Overland Park, KS 66207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0100a-d23f-742a-809d-e3b3af0e1315.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-d23f-742a-809d-e3b3af0e1315",
        "storage_key": "property/6767906449167624/01a0100a-d23f-742a-809d-e3b3af0e1315.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.opkansas.org/park/nall-hills-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15640790860681485836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nall-hills-park",
      "poi_latitude": "38.938963",
      "poi_longitude": "-94.651414",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-cdb0-7199-850a-4fece608df48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-cdb0-7199-850a-4fece608df48",
        "storage_key": "property/6767906449167624/019fc995-cdb0-7199-850a-4fece608df48.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_3cm1f7rwIcRDJ4YWWtAD9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_df78105d-18e9-471d-b7a1-ef087628615e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "B&B Theatres Overland Park 16",
      "poi_type": "Entertainment",
      "poi_address": "8601 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_long_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019ff6a4-471a-70c9-b32b-61d8626e3ddc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-471a-70c9-b32b-61d8626e3ddc",
        "storage_key": "property/6767906449167624/019ff6a4-471a-70c9-b32b-61d8626e3ddc.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://www.bbtheatres.com/our-theatres/x0uvh-b-and-b-overland-park-16/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6259761698616561138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bb-theatres-overland-park-16",
      "poi_latitude": "38.8812512",
      "poi_longitude": "-94.6835183",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-871-5352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7d9-7757-b2e6-ca3cb2fd13a9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7d9-7757-b2e6-ca3cb2fd13a9",
        "storage_key": "property/6767906449167624/019fc995-c7d9-7757-b2e6-ca3cb2fd13a9.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJDWO_qc3BwIcR8s2iaBkk31Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_8ff77492-cc12-4342-b953-1068c9dfe800",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Blue Valley Church: Antioch Campus",
      "poi_type": "Transportation & Transit",
      "poi_address": "8925 W 151st St, Overland Park, KS 66221, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-d583-772c-80eb-125c20308aeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-d583-772c-80eb-125c20308aeb",
        "storage_key": "property/6767906449167624/01a0b672-d583-772c-80eb-125c20308aeb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://bluevalleychurch.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17990318900224087284&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-valley-church-antioch-campus",
      "poi_latitude": "38.8538327",
      "poi_longitude": "-94.6875984",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-897-9669",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019ff6a4-a8d2-75a6-a5a5-f01f9d157fd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-a8d2-75a6-a5a5-f01f9d157fd7",
        "storage_key": "property/6767906449167624/019ff6a4-a8d2-75a6-a5a5-f01f9d157fd7.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJd34mPVXAwIcR9FTaE7lzqvk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_ad2f5a63-f7d0-4255-9146-72a7957a08ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Heartland Community Church",
      "poi_type": "Transportation & Transit",
      "poi_address": "12175 S Strang Line Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019ff6a4-7fc6-71c8-b23c-421298722667.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-7fc6-71c8-b23c-421298722667",
        "storage_key": "property/6767906449167624/019ff6a4-7fc6-71c8-b23c-421298722667.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.heartlandchurch.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11439840584445010142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heartland-community-church",
      "poi_latitude": "38.9077079",
      "poi_longitude": "-94.7721404",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 913-341-5820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019ff6a4-a8d2-75a6-a5a5-f01f9d157fd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-a8d2-75a6-a5a5-f01f9d157fd7",
        "storage_key": "property/6767906449167624/019ff6a4-a8d2-75a6-a5a5-f01f9d157fd7.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJtZEk2J6VwIcR3iDxkmZ6wp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_053b6bed-a725-455b-9489-6d1c747b49da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Mission Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5251 Johnson Dr, Roeland Park, KS 66205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ridekc.org/locations/mission_transit_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14750820283784844061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-transit-center",
      "poi_latitude": "39.0229186",
      "poi_longitude": "-94.6460432",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-cdff-722f-b4e6-64fdd86dbffb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-cdff-722f-b4e6-64fdd86dbffb",
        "storage_key": "property/6767906449167624/019fc995-cdff-722f-b4e6-64fdd86dbffb.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RGVf9XtwIcRHVOfGOVwtcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_7da1c0c6-79ce-45ca-92f3-faa4d15f7f19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Oak Park Mall Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13146997606835839132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall-park-and-ride",
      "poi_latitude": "38.954938",
      "poi_longitude": "-94.715914",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019ff6a4-a8cf-77c9-937e-0750bcaae9d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-a8cf-77c9-937e-0750bcaae9d0",
        "storage_key": "property/6767906449167624/019ff6a4-a8cf-77c9-937e-0750bcaae9d0.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJv9bmcDjrwIcRnGBc6qqEc7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_c9446dcc-005b-41f5-b7f7-1210bacb71c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc994-f1d3-72ac-a9db-83290be20722.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-f1d3-72ac-a9db-83290be20722",
        "storage_key": "property/6767906449167624/019fc994-f1d3-72ac-a9db-83290be20722.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3013901",
      "poi_longitude": "-94.7104232",
      "poi_miles_from_property": "38",
      "poi_walking_minutes": "14 hours 9 mins",
      "poi_biking_minutes": "4 hours 8 mins",
      "poi_driving_minutes": "41 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-d01d-72ec-92c0-75efb4541343.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-d01d-72ec-92c0-75efb4541343",
        "storage_key": "property/6767906449167624/019fc995-d01d-72ec-92c0-75efb4541343.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_d931ce77-5cc3-4263-bb79-b18bdf535119",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Hyatt Place Kansas City/Lenexa City Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "8741 Ryckert St, Lenexa, KS 66219, USA",
      "poi_short_description": "Understated rooms & suites in a relaxed hotel with a gym, an indoor pool & a cafe/bar.",
      "poi_long_description": "Understated rooms & suites in a relaxed hotel with a gym, an indoor pool & a cafe/bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-d775-75ae-af85-79f316d6a6a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-d775-75ae-af85-79f316d6a6a3",
        "storage_key": "property/6767906449167624/01a0b672-d775-75ae-af85-79f316d6a6a3.webp",
        "width": 1280,
        "height": 579
      },
      "poi_business_url": "https://www.hyatt.com/hyatt-place/en-US/mkczl-hyatt-place-kansas-city-lenexa-city-center?src=corp_lclb_google_seo_mkczl&utm_source=google&utm_medium=organic&utm_campaign=lmr",
      "poi_directions_map_url": "https://maps.google.com/?cid=6789786362053878651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hyatt-place-kansas-citylenexa-city-center",
      "poi_latitude": "38.9690345",
      "poi_longitude": "-94.7777598",
      "poi_miles_from_property": "12.4",
      "poi_walking_minutes": "4 hours 38 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 913-742-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-e41c-706c-ad5f-933b5f33069b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0b672-e41c-706c-ad5f-933b5f33069b",
        "storage_key": "property/6767906449167624/01a0b672-e41c-706c-ad5f-933b5f33069b.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJYwaLj3mUwIcRe2MD87gqOl4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_73bcaf66-7c4f-4337-a0d2-394bd93e7894",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Overland Park Convention Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3983818594579154713&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-convention-center",
      "poi_latitude": "38.92910699999999",
      "poi_longitude": "-94.6557786",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-d01e-7078-813d-4020c53f7416.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-d01e-7078-813d-4020c53f7416",
        "storage_key": "property/6767906449167624/019fc995-d01e-7078-813d-4020c53f7416.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJqe0M0zHqwIcRGYd8k-ddSTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_886adc69-d6ba-4192-b630-274979b5f0ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Three Trails Transit Ctr Southbound Lane",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, MO 64138, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019ff6a4-8e1e-7423-a9a2-5734a13ee31f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-8e1e-7423-a9a2-5734a13ee31f",
        "storage_key": "property/6767906449167624/019ff6a4-8e1e-7423-a9a2-5734a13ee31f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11578073823919471817&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "three-trails-transit-ctr-southbound-lane",
      "poi_latitude": "38.953192",
      "poi_longitude": "-94.507295",
      "poi_miles_from_property": "11.2",
      "poi_walking_minutes": "4 hours 11 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019ff6a4-a8cf-77c9-937e-0750bcaae9d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-a8cf-77c9-937e-0750bcaae9d0",
        "storage_key": "property/6767906449167624/019ff6a4-a8cf-77c9-937e-0750bcaae9d0.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJeTIM9uXmwIcRyfz3scyUraA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_f64db744-fbd2-4f61-a69d-9469792feef1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Aspiria",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6140 Sprint Pkwy STE 125, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-2a61-7361-a458-808e5d52c2b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-2a61-7361-a458-808e5d52c2b5",
        "storage_key": "property/6767906449167624/019fc995-2a61-7361-a458-808e5d52c2b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://aspiriakc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6433786320914474865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aspiria",
      "poi_latitude": "38.9169728",
      "poi_longitude": "-94.6568885",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-285-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-8d7636d013d2",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0ZxsczrwIcRceffOpJmSVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_26efadc7-c5b7-436d-b8db-c50a5983af4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Black & Veatch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11401 Lamar Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-1c59-706e-907b-370ff9db80d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-1c59-706e-907b-370ff9db80d5",
        "storage_key": "property/6767906449167624/019fc995-1c59-706e-907b-370ff9db80d5.webp",
        "width": 1280,
        "height": 653
      },
      "poi_business_url": "http://www.bv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15245877116558125981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black--veatch",
      "poi_latitude": "38.9250015",
      "poi_longitude": "-94.6553624",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-458-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-8d7636d013d2",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyTe2TrqwIcRnSu0HXY8lNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_3ba6f036-d289-43b0-ba30-2323f5615447",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Menorah Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5721 W 119th St, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc991-f029-73b7-ad63-ec5825dd7356.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-f029-73b7-ad63-ec5825dd7356",
        "storage_key": "property/6767906449167624/019fc991-f029-73b7-ad63-ec5825dd7356.webp",
        "width": 1280,
        "height": 983
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/menorah-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13288974551408218760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "menorah-medical-center",
      "poi_latitude": "38.9108041",
      "poi_longitude": "-94.6515422",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-498-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-cdb1-7603-adf2-1b856d80f4d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-cdb1-7603-adf2-1b856d80f4d0",
        "storage_key": "property/6767906449167624/019fc995-cdb1-7603-adf2-1b856d80f4d0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJa9T6FxnqwIcRiJLkTfLra7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_77589a52-09bf-4d2a-ac42-9428940e0bba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Corporate Woods Office Park",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8717 W 110th St Ste 240, Overland Park, KS 66210, USA",
      "poi_short_description": "Business center featuring 29 buildings and ample parking, plus a trail.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019ff6a4-977f-7609-8b97-a1ee0d23c571.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a4-977f-7609-8b97-a1ee0d23c571",
        "storage_key": "property/6767906449167624/019ff6a4-977f-7609-8b97-a1ee0d23c571.webp",
        "width": 828,
        "height": 315
      },
      "poi_business_url": "http://www.corporatewoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2514230223847482340&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corporate-woods-office-park",
      "poi_latitude": "38.9282565",
      "poi_longitude": "-94.6879131",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-451-4466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-8d7636d013d2",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS-FZjPjqwIcR5OP6TxFX5CI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "custom_c23c98b0-6866-4d13-8744-7250a60e4f70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Blue Valley School District Office #229",
      "poi_type": "Major Employers & Offices",
      "poi_address": "15020 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bluevalleyk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12406361877646761667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-valley-school-district-office-229",
      "poi_latitude": "38.8566433",
      "poi_longitude": "-94.6685552",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-239-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-92368c39738d",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkUYMDKHBwIcRw14VYGVALKw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5a72cd39-f631-4c71-a44d-54cb41b2f5c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "SMSD Center for Academic Achievement",
      "poi_type": "Education",
      "poi_address": "8200 W 71st St, Overland Park, KS 66204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b672-dc1a-77c7-b52e-6a21f35db15a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b672-dc1a-77c7-b52e-6a21f35db15a",
        "storage_key": "property/6767906449167624/01a0b672-dc1a-77c7-b52e-6a21f35db15a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13529336476659713433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smsd-center-for-academic-achievement",
      "poi_latitude": "39.0014907",
      "poi_longitude": "-94.6802101",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 913-993-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-92368c39738d",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-92368c39738d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF9r8VFzswIcRmYUJEtjbwbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d7ae3377-b9ba-4e53-9cad-59cfc4a4838c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "custom",
      "poi_name": "Garmin",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-0799-774c-abd5-3185881ca54e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc995-0799-774c-abd5-3185881ca54e",
        "storage_key": "property/6767906449167624/019fc995-0799-774c-abd5-3185881ca54e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.garmin.com/en-US",
      "poi_directions_map_url": "https://maps.google.com/?cid=7856958804647333168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garmin",
      "poi_latitude": "38.8553721",
      "poi_longitude": "-94.7996464",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 800-800-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc995-c7c9-733a-96ad-8d7636d013d2",
        "storage_key": "property/6767906449167624/019fc995-c7c9-733a-96ad-8d7636d013d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdY73mS-wIcRMM3hpWeGCW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_f254837c7b5201320cf8e288",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_fa7b4c9cee8d59c6b8e0faa8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_dd1d69091c637795294f67bc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6d0ea9db379da95f87b0a02c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_d028ff61de71e1a360640b06",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b7cd150f85e36838d84bf1f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_239809859dab684a5516adf0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "rating": "5",
      "name": "false",
      "text": "I have lived at Wynnewood Farms for several years now. The apartment is just the right size, and right across the street from 3 malls and several restaraunts plus numerous entertainment venues. The staff at Wynnewood Farms make you feel like your part of the family, that is why I have stayed here all these years.",
      "date": "false",
      "title": "My Wynnewood"
    },
    {
      "id": "ec_9d4683df82ef5fe7b746ead4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "rating": "4",
      "name": "false",
      "text": "I have lived here from just under a year. Initially, as I just looked at the outside of the complex, I did not want to move here. I had wanted to move into one of several brand new complexes. But the fact that I needed an attached garage made the decision for me since none of them had them.\n\nIt was a good decision. \n\nYes, it is older (how old I don't know). But it has been well kept considering.  And all in all, I like the layout. My mother lives with me so we are in a 2-Bedroom. And unlike all of the other places I visited, this was the only one where the bedrooms were at opposite ends of the apartment - great for privacy. \n\nAnother significant aspect is the managerial staff. They were very pleasant and helpful during the consideration process, especially then assistant manager. Always smiling, always quick to answer multiple questions I had during call backs. Now I thought it might be like some service when before you buy the product all is rosy but when bought the service stinks. Not so. The staff continues to provide outstanding service even though three of the four were rotated out to other apartments owned by the company. The one who stay was assistant manager who was promoted to manager. \n\nAs for price, I would consider fair market value - not too high but not inexpensive.\n\nThumbs up.",
      "date": "false",
      "title": "Older Place, Fantastic Service"
    },
    {
      "id": "ec_72613e00cc296e096cffdb38",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "rating": "5",
      "name": "false",
      "text": "I have lived at Wynnewood Farms for the past four years. I really like the layout of my apartment and the location. There is a wooded area behind my building and a pond. My neighbors have always been friendly and courteous. There have been two managers since I have lived there and they have both been helpful whenever I have a concern. The apartment complex is not brand new, so I have had to have maintenance take care of some things. My requests are normally completed by the next day. The location is ideal for me since it is close to my child's school and there is a walking trail adjacent to my place. It is across the street from Prairie Fire and within a few minutes from the highway (69 and I435).The thing that I most enjoy about Wynnewood is the laid back vibe. The pool is never over crowded or rowdy. Great place to call home!",
      "date": "false",
      "title": "Wynnewood Farms"
    },
    {
      "id": "ec_9dbfbdc39e046abfa048cefa",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "rating": "5",
      "name": "false",
      "text": "When I moved in, I already expected things in the apartment to not be perfect which it was. However, my apartment complex managers and team sufficed. They always delivered in a timely manner and was always readily available when needed. I also appreciate the cleanliness and scenic nature of my apartment complex. It motivates me to workout because I am always impressed by the view when I take a causal stroll or run. Lastly, I appreciate the way they keep you informed about events and activities going on in the community. I am so glad that my wife and I decided to move to Wynnewood Farms because it has been nothing but a blessing to us.",
      "date": "false",
      "title": "Wynnewood Farms"
    },
    {
      "id": "ec_40be30abb6b9f09c99b4c78e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "rating": "5",
      "name": "false",
      "text": "Wynnewood Farms have provided a worry-free life style for a young lady like myself. With a provided pool, gym, and lounge it's hard to even want to leave the complex! When any problems occur, if any, the maintenance team arrives quickly and gets the job done. Compared to the apartments surrounding the area, Wynnewood Farms makes you feel like you're living in the city without the chaos.",
      "date": "false",
      "title": "I'm On My Own!"
    },
    {
      "id": "ec_b562022e893ca71734be2635",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "rating": "5",
      "name": "false",
      "text": "I have been living at Wynnewood Farms apartments for the past seven months. I have had an amazing experience. The apartments are spacious and it's free from bugs of any kind. I live in the Ethan styled apartment and I really benefit from the added study. The maintenance team is just excellent. All maintanence issues are addressed within 24 hours of reporting. Well kept pool and club house. Thank you apartments.com for the reviews that helped me select Wynnewood Farms, and I haven't regretted it one bit.",
      "date": "false",
      "title": "Beautiful experience"
    },
    {
      "id": "ec_09bc074e18a4693c4a6888a7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "rating": "5",
      "name": "false",
      "text": "We have lived here since Aug. 2013.  We are both retired . And have enjoyed our move from another apt. We like the arrangement of bedrooms, nice when u have over night guests. We are in the court yard, our mailbox is just a few steps away! The complex has a lot of beautiful grow trees, new apts. may be new but they have no trees!!! \nWe have GREAT office crew! Our maintenance guys u could not ask for anyone better, they know how to get a job done!!!!\nAlso found people more friendly than other apt. We have lived in....B & D",
      "date": "false",
      "title": "Wynnewood Farms"
    },
    {
      "id": "ec_d817d96c1cddc83b221d99ea",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "rating": "5",
      "name": "false",
      "text": "Great place to live 9 years and counting. Maintenance is outstanding and office very helpful.",
      "date": "false",
      "title": "Carla Murphy"
    },
    {
      "id": "ec_2d4edaf1daec958ac51b17c3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "rating": "4",
      "name": "false",
      "text": "As a transplant to this area I couldn't have chosen a better apartment community. The location allowed me to adapt to the greater metropolitan area right away. We are five minutes from restaurants, shopping, entertainment, churches, schools, medical facilities, and more. The community isn't new but the apartments are spacious and well maintained. You have 24 hour maintenance, and the maintenance staff is capable and professional.  The office staff goes above and beyond to make your life here pleasant and carefree.   This is a small community allowing residents to know their neighbors therefore feeling a lot safer. The grounds are beautiful and walkways are walkable during even the most harsh winters. Our lovely pool is refreshing during the summer months and we enjoy as a community at our annual pool party. I recommend Wynnewood Farms as a nice quiet, serene, friendly place to live.",
      "date": "false",
      "title": "Audrey D"
    },
    {
      "id": "ec_b80454a7cb86eb084a0c9595",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "rating": "5",
      "name": "false",
      "text": "I moved her in September 14, 2018. I’ve had to call maintenance several times. They responded right away and the leasing staff call to make sure my request was taken care of. Some of the buildings got painted last year. The grounds are beautiful. The residents are very friendly. The staff are friendly and helpful. They make you feel welcomed. This is my second Price Brothers property. I have had two  three bedroom apartments. The layout is great and I like the attention to detail is beautiful. I can’t wait to use the pool. I love living here.",
      "date": "false",
      "title": "Great place to live"
    },
    {
      "id": "ec_d547cff64366bffafceecab7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "rating": "5",
      "name": "false",
      "text": "This is HOME! We love it here. The office staff is great. Very friendly. The grounds are beautifully maintained and the apt is beautiful! We have found HOME!",
      "date": "false",
      "title": "Just signed our lease for the 3rd year!"
    },
    {
      "id": "ec_e5affe6fd7139989579be2e6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "rating": "5",
      "name": "false",
      "text": "I love Wynnewood Farms. \nThe staff is so friendly and \nvery professional. They go\nthe extra mile to keep tenants\nhappy. I can always count on\nMaintenance take care of any\nmaintenance issues. The grounds\nare beautiful. I like the social events\nwe have at the Club House also.\n",
      "date": "false",
      "title": "Home Sweet Home"
    },
    {
      "id": "ec_54aa0e48a250fd815f9c3374",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "rating": "5",
      "name": "false",
      "text": "I absolutely love living at Wynnewood Farms. Everyone in the office is very friendly and they know you by name which makes it even better. My boyfriend and I live in the \"Edmund\" floor plan. Lots of square footage, we've never had any issues. The walk in closet is huge and the bathtub is also very spacious. Maintenance is very responsive if you have to put in a request. The grounds are very nice, lots of trees and the location is great. We also enjoy the pool area and the workout center. Great price for the location! Wouldn't want to live anywhere else! ",
      "date": "false",
      "title": "I love Wynnewood Farms! "
    },
    {
      "id": "ec_016a78ac4b09fc23c6043761",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "rating": "5",
      "name": "false",
      "text": "Clean, quiet environment. Downsizing from a home was a shock at first. This is my first apartment experience since college but the transition has been smooth. The Wynnewood community staff is friendly and has been responsive to maintenance requests seven days a week. Price Bros. makes sure the complex is maintained in a first-class fashion. ",
      "date": "false",
      "title": "Starting My 6th Year as a Wynnewood Farms Resident"
    },
    {
      "id": "ec_cf5131e2e3ece2d67f0a38a3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "rating": "5",
      "name": "false",
      "text": "Wouldn’t think twice about recommending to someone! Thank you to Jessica and her staff for putting up with myself and my pup for the past 3 years??",
      "date": "false",
      "title": "Great complex!"
    },
    {
      "id": "ec_4a5aa59906a5b71b5b002801",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "rating": "5",
      "name": "false",
      "text": "Very nice apartment with great amenities. Close range to a lot of spots.",
      "date": "false",
      "title": "Great community!!"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_372e292e344f1ec2ab4e0347",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67c-97ab-75c2-98e6-ca335f7175f0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b67c-97ab-75c2-98e6-ca335f7175f0",
        "storage_key": "property/6767906449167624/01a0b67c-97ab-75c2-98e6-ca335f7175f0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "ASTON",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=E8ySt8tqgez"
    },
    {
      "id": "ec_47eb5f5792d213148fabf60a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67c-f5c0-76dc-a8f8-9324ba913eb0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b67c-f5c0-76dc-a8f8-9324ba913eb0",
        "storage_key": "property/6767906449167624/01a0b67c-f5c0-76dc-a8f8-9324ba913eb0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "EDMUND",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=A7wyVw1Y1ZZ"
    },
    {
      "id": "ec_ab0b7af98c4675757eee5bd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67c-9757-71ba-8172-222f367167b3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b67c-9757-71ba-8172-222f367167b3",
        "storage_key": "property/6767906449167624/01a0b67c-9757-71ba-8172-222f367167b3.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "GASTON",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=wDosS3vicGF"
    },
    {
      "id": "ec_a8d4ccd5503b185a641529c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67c-b1c1-779d-8311-2d7110b7c731.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b67c-b1c1-779d-8311-2d7110b7c731",
        "storage_key": "property/6767906449167624/01a0b67c-b1c1-779d-8311-2d7110b7c731.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "BELLA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=pkLg7BwtK4s"
    },
    {
      "id": "ec_ba0e9abfb54a23f2faf41906",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67c-d097-72ed-ba8f-cb61af03130a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b67c-d097-72ed-ba8f-cb61af03130a",
        "storage_key": "property/6767906449167624/01a0b67c-d097-72ed-ba8f-cb61af03130a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "DALTON",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=iqt2EYm9zP6"
    },
    {
      "id": "ec_80ce4007c805c43fd8885075",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67d-0362-77f9-ba29-fb91e3064ce6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b67d-0362-77f9-ba29-fb91e3064ce6",
        "storage_key": "property/6767906449167624/01a0b67d-0362-77f9-ba29-fb91e3064ce6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "ETHAN",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Exh545Bd2sB"
    },
    {
      "id": "ec_59f04c6f29994324ace9a9d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167624/01a0b67d-0cfc-716b-990e-5ae96b2b26a2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b67d-0cfc-716b-990e-5ae96b2b26a2",
        "storage_key": "property/6767906449167624/01a0b67d-0cfc-716b-990e-5ae96b2b26a2.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "CORIN",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=d5wCEffrfUs"
    }
  ],
  "faqs": [
    {
      "id": "custom_d5768440-ba57-4b7e-b9c9-adff0c529e0e",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_0498ca80-efdb-47ca-b3ea-f4d21a95c912",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_bf118176-2d7a-4890-9781-0f11c3e9845f",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_024cfc21-1bc9-490e-84bd-4072cc100264",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_b54c8b7a-be31-405d-a4a8-35574fb6a3b2",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d387dd46-cfc6-4670-b7a1-d50d7108809e",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_ce253b58-472f-4ce3-8aa5-5b3a446bbb90",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_e0917e03-fff3-4447-a1c9-702be523866c",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, trash, and electric.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_be809652-37ad-440e-ae10-a6bea3d87fc3",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_1f2ad762-699f-48c7-a775-a928ce6de4ea",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_f845ab68-e074-4aa6-8212-5f677067112e",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_fc23a32a-ab0c-4156-b9ca-f28d63f993d2",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_4bd3c85e-ab80-42f5-b934-7006c7361705",
      "question": "Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_2905e541-ab0c-41a6-abad-356122be3c97",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer carports. Please <a href=\"/contact-us\">contact the office</a> for our most current carport availability and pricing.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_016aff28-f277-4d18-a4d2-2b407c5766b7",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_387ff3bb-44ec-42fe-ad10-b475bbefda14",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_b8e0c37c-658d-4bbe-b2bc-a0adc4bae9c9",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-532f-7690-86f7-414011eaf962",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Wynnewood Farms Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624"
    },
    {
      "lead_collector_id": "01a0c9ac-53a3-76a1-95bd-cdd81a5aa37a",
      "lead_source": "LANDING_PAGE",
      "name": "Wynnewood Farms Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "apartments-for-rent-in-unit-laundry-overland-park",
      "search_query": "apartments for rent with in-unit laundry Overland Park KS",
      "category": "Amenity",
      "h1_title": "Find Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover the convenience of in-unit laundry. Explore spacious apartments for rent with in-home washers and dryers at Wynnewood Farms, Overland Park.",
      "page_copy": "Experience the ultimate convenience of having in-home washers and dryers in your apartment. Wynnewood Farms offers stylish one-, two-, and three-bedroom homes equipped with in-unit laundry facilities. Located in the serene neighborhood of Overland Park, KS, our community ensures you enjoy everyday comforts without leaving home.\n\nFrom polished finishes to community amenities like package service and disability access, Wynnewood Farms is designed with your lifestyle in mind. Schedule a tour to see how our apartments for rent with in-unit laundry set the standard in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overland Park Apartments: In-Unit Laundry",
      "seo_description": "Discover Wynnewood Farms: Apartments for rent with in-unit laundry in Overland Park, KS. Enjoy modern living with everyday comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "luxury-apartments-air-conditioning-johnson-county",
      "search_query": "luxury apartments with air conditioning Johnson County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with A/C in Johnson County",
      "h2_subtitle": "Discover luxury living with air conditioning. Wynnewood Farms in Johnson County offers refined apartment homes with modern comforts.",
      "page_copy": "Wynnewood Farms provides luxury living in the heart of Johnson County. Our one-, two-, and three-bedroom apartments come with air conditioning to ensure your comfort, no matter the season. Dive into a high-end lifestyle where elevated finishes and premium amenities enhance your living experience.\n\nLocated in South Overland Park, KS, our community also offers features like package services and disability access, ensuring every resident enjoys both comfort and convenience. With air conditioning as a standard, enjoy modern luxury in a community designed with you in mind. Book a tour today to see Wynnewood Farms for yourself.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with A/C in Johnson County",
      "seo_description": "Explore luxury apartments at Wynnewood Farms, Johnson County with air conditioning. Upscale living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "apartments-with-pool-overland-park-ks",
      "search_query": "apartments with a pool in Overland Park KS",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Overland Park",
      "h2_subtitle": "Enjoy refreshing poolside living at Wynnewood Farms. Explore our Overland Park community and enhance your lifestyle with this appealing amenity.",
      "page_copy": "Dive into luxurious living at Wynnewood Farms, where you can enjoy the perks of having a refreshing pool right at your doorstep. Our one-, two-, and three-bedroom apartments in Overland Park, KS provide a perfect blend of comfort and style, complemented by community amenities like a sparkling pool.\n\nLocated in the inviting neighborhood of South Overland Park, Wynnewood Farms offers more than just a place to live. With additional features including stainless steel appliances and package service, every detail has been considered for your convenience. Schedule a visit today and discover why our apartments with a pool stand out in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overland Park Apartments with Pool",
      "seo_description": "Discover Wynnewood Farms: Apartments with a pool in Overland Park, KS. Enjoy community amenities and a refreshing swimming experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-near-wynnewood",
      "search_query": "dog-friendly apartments near Wynnewood",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments Near Wynnewood",
      "h2_subtitle": "Embrace pet-friendly living at Wynnewood Farms. Discover spacious apartments near Wynnewood that welcome your furry friends.",
      "page_copy": "At Wynnewood Farms, we understand that pets are family too. That's why our community offers dog-friendly living in a scenic area near Wynnewood, ensuring both you and your four-legged friend enjoy a comfortable lifestyle. Our one-, two-, and three-bedroom apartments provide ample space for everyone—pets included!\n\nLocated in Overland Park, KS, Wynnewood Farms combines luxury with pet-friendly amenities and an inviting neighborhood perfect for walks. With our community's focus on welcoming all members of your household, book a tour today to see how Wynnewood Farms can be the ideal home for you and your pet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments Near Wynnewood",
      "seo_description": "Find your new home at Wynnewood Farms: Dog-friendly apartments near Wynnewood with spacious accommodations for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-overland-park",
      "search_query": "apartments with dishwasher in Overland Park",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Overland Park",
      "h2_subtitle": "Explore Wynnewood Farms' modern homes with dishwashers. Enjoy hassle-free living in Overland Park's vibrant community.",
      "page_copy": "Wynnewood Farms offers modern, stylish living with the convenience of in-home dishwashers in every apartment. Located in the heart of Overland Park, KS, our one-, two-, and three-bedroom homes provide a blend of luxury and practicality, ensuring your daily routines are effortless and enjoyable.\n\nExperience the difference of living in a community that prioritizes both comfort and function. Alongside stainless steel appliances, in-home washers and dryers, and other select amenities, our apartments are designed to simplify your life. Visit us today and see why Wynnewood Farms is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overland Park Apartments with Dishwasher",
      "seo_description": "Discover Wynnewood Farms: Apartments with dishwashers in Overland Park. Enjoy modern conveniences in a lively community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-overland-park",
      "search_query": "one bedroom apartments overland park",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Overland Park",
      "h2_subtitle": "Discover spacious one bedroom apartments at Wynnewood Farms. Embrace comfort and style in Overland Park.",
      "page_copy": "Explore the charm of living in a one bedroom apartment at Wynnewood Farms, perfectly situated in Overland Park, KS. Our thoughtfully designed homes offer a sophisticated blend of style and practicality, complete with modern kitchens and sleek finishes that cater to your lifestyle needs.\n\nLocated in the desirable neighborhood of South Overland Park, Wynnewood Farms enhances your living experience with community comforts like disability access and a sparkling pool. Visit us today and see how our one bedroom apartments can simplify and elevate your life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Overland Park",
      "seo_description": "Find your ideal one bedroom apartment at Wynnewood Farms, Overland Park. Enjoy modern living in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-johnson-county",
      "search_query": "two bedroom apartments johnson county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Johnson County",
      "h2_subtitle": "Discover Wynnewood Farms' spacious two bedroom apartments. Experience luxury living in Johnson County.",
      "page_copy": "Wynnewood Farms offers exceptional two bedroom apartments in the heart of Johnson County. Designed for modern living, these homes provide ample space and feature elevated amenities, including in-home washers and dryers and available attached garages, making them ideal for families or roommates.\n\nNestled in South Overland Park, our community combines comfort with convenience, set in a prime location that allows easy access to local attractions. Enjoy community-focused amenities like a package service and a welcoming neighborhood atmosphere. Schedule a tour to see firsthand why Wynnewood Farms is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Johnson County",
      "seo_description": "Explore Wynnewood Farms: Spacious two bedroom apartments in Johnson County. Enjoy a blend of luxury and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-wynnewood-ks",
      "search_query": "three bedroom apartments wynnewood ks",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Wynnewood KS",
      "h2_subtitle": "Explore spacious three bedroom apartments at Wynnewood Farms in KS. Ideal for families and roommates seeking comfort and style.",
      "page_copy": "Discover the perfect home with our spacious three bedroom apartments at Wynnewood Farms in Wynnewood, KS. These thoughtfully designed homes offer generous living spaces, making them ideal for families or those who love entertaining. Enjoy modern finishes with stainless steel appliances and the convenience of in-home washers and dryers.\n\nLocated in the serene community of South Overland Park, Wynnewood Farms provides a peaceful retreat with amenities like a package service and disability access. Explore the beautiful surroundings and enjoy being part of a vibrant, welcoming neighborhood. Visit today to see why our three bedroom homes are a top choice in Wynnewood, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Wynnewood KS",
      "seo_description": "Find your spacious three bedroom apartment at Wynnewood Farms, KS. Perfect for families seeking modern living in a great community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "apartments-near-overland-trail-elementary",
      "search_query": "apartments near Overland Trail Elementary School Overland Park",
      "category": "School",
      "h1_title": "Apartments Near Overland Trail Elementary",
      "h2_subtitle": "Find your next home near Overland Trail Elementary School. Wynnewood Farms offers the ideal location in Overland Park.",
      "page_copy": "Nestled conveniently in South Overland Park, Wynnewood Farms offers ideal living for families seeking apartments near Overland Trail Elementary School. Our community prides itself on being close to quality education opportunities, making it easier for families to balance home and school life.\n\nFeaturing beautifully designed one, two, and three-bedroom apartments, Wynnewood Farms ensures residents enjoy modern comforts and amenities, such as package services and 24-hour access, in a welcoming environment. Embrace the convenience and comfort of living minutes away from Overland Trail Elementary School while enjoying the vibrant community spirit of Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Trail Elementary",
      "seo_description": "Discover Wynnewood Farms: The perfect family-friendly apartments near Overland Trail Elementary in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "apartments-near-overland-trail-middle-school",
      "search_query": "apartments close to Overland Trail Middle School in Wynnewood",
      "category": "School",
      "h1_title": "Apartments Close to Overland Trail Middle School",
      "h2_subtitle": "Discover Wynnewood Farms offering a prime location near Overland Trail Middle School in Wynnewood.",
      "page_copy": "Wynnewood Farms is the perfect choice for families seeking apartments close to Overland Trail Middle School in the friendly Wynnewood neighborhood. Offering an unbeatable location, our community provides easy access to quality education while allowing families to enjoy a comfortable and convenient lifestyle.\n\nThe spacious one, two, and three-bedroom homes are designed with modern finishes, such as stainless steel appliances and available attached garages. Residents also benefit from community amenities like package service and disability access. Come explore how living at Wynnewood Farms can enhance your Overland Park experience, all while staying close to Overland Trail Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Overland Trail Middle School",
      "seo_description": "Live near Overland Trail Middle School in Wynnewood. Choose Wynnewood Farms for a convenient and family-friendly environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "johnson-county-apartments-near-blue-valley-north",
      "search_query": "Johnson County KS apartments near Blue Valley North High School",
      "category": "School",
      "h1_title": "Apartments Near Blue Valley North High School",
      "h2_subtitle": "Explore apartments located conveniently near Blue Valley North High School in Johnson County, KS. Wynnewood Farms offers a premier living experience.",
      "page_copy": "Wynnewood Farms is strategically located in Johnson County, KS, offering premium apartments near Blue Valley North High School. Perfect for families prioritizing education, our community ensures that you’re just minutes away from one of the top schools in the area.\n\nOur well-designed one, two, and three-bedroom homes come with modern conveniences like in-home washers and dryers, and select units feature attached garages. Residents can enjoy community amenities such as package services and disability access. Experience the best of Johnson County living at Wynnewood Farms, close to Blue Valley North High School, and see why it’s the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Johnson County Apartments Near Blue Valley North",
      "seo_description": "Find the perfect home near Blue Valley North High School. Choose Wynnewood Farms in Johnson County, KS for a premier living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "overland-park-apartments-near-valley-park-elementary",
      "search_query": "Valley Park Elementary School nearby Overland Park apartments",
      "category": "School",
      "h1_title": "Overland Park Apartments Near Valley Park Elementary",
      "h2_subtitle": "Wynnewood Farms offers apartments conveniently located near Valley Park Elementary School in Overland Park.",
      "page_copy": "For families seeking the perfect balance of proximity and comfort, Wynnewood Farms is your destination. Our community in Overland Park features apartments situated close to Valley Park Elementary School, ensuring a short commute for students and peace of mind for parents.\n\nOffering one, two, and three-bedroom homes, Wynnewood Farms provides modern living arrangements, including select attached garages and luxury finishes. Community perks like package service and disability access enhance the experience, making it a top choice for families. Discover the benefits of living near Valley Park Elementary School at Wynnewood Farms, where convenience meets quality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Valley Park Elementary School",
      "seo_description": "Discover Wynnewood Farms: Prime Overland Park apartments near Valley Park Elementary School offering modern living and community comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "apartments-mission-trail-elementary-wynnewood",
      "search_query": "Mission Trail Elementary School apartments in Wynnewood KS",
      "category": "School",
      "h1_title": "Apartments by Mission Trail Elementary in Wynnewood",
      "h2_subtitle": "Find the perfect home at Wynnewood Farms, located near Mission Trail Elementary School in Wynnewood, KS.",
      "page_copy": "Nestled in the charming Wynnewood neighborhood, Wynnewood Farms offers ideal apartments near Mission Trail Elementary School. This location is perfect for families looking to balance educational proximity with comfortable living in Wynnewood, KS.\n\nOur one, two, and three-bedroom apartments feature upscale amenities like in-home washers and dryers, and some units come with attached garages. With additional benefits such as a reliable package service and disability access, Wynnewood Farms provides both convenience and quality. Come see how living near Mission Trail Elementary School combines the best of community living with educational access.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wynnewood KS Apartments Near Mission Trail Elementary",
      "seo_description": "Wynnewood Farms provides comfortable living near Mission Trail Elementary. Discover modern apartments in Wynnewood, KS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "johnson-county-apartments-near-nativity-parish-school",
      "search_query": "apartments near Nativity Parish School in Johnson County",
      "category": "School",
      "h1_title": "Apartments Near Nativity Parish School",
      "h2_subtitle": "Discover Wynnewood Farms, offering apartments conveniently located near Nativity Parish School in Johnson County.",
      "page_copy": "Located in Johnson County, Wynnewood Farms presents an ideal living option for those seeking apartments near Nativity Parish School. Our community ensures that you are just minutes away from this esteemed educational institution, providing ample convenience for busy families.\n\nChoose from our stylish one, two, and three-bedroom apartment homes, each thoughtfully designed with features like in-home washers and dryers and select units offering attached garages. At Wynnewood Farms, residents benefit from amenities such as package services and disability access, making it a desirable place to reside. Experience the seamless blend of quality education and modern living right here near Nativity Parish School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Johnson County Apartments Close to Nativity Parish School",
      "seo_description": "Find modern apartments near Nativity Parish School in Johnson County at Wynnewood Farms, offering comfort and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "south-overland-park-apartments-near-johnson-county-college",
      "search_query": "Johnson County Community College nearby South Overland Park apartments",
      "category": "School",
      "h1_title": "Apts Near Johnson County Community College",
      "h2_subtitle": "Explore Wynnewood Farms' South Overland Park apartments, conveniently located near Johnson County Community College.",
      "page_copy": "Wynnewood Farms offers a vibrant community in South Overland Park, perfect for those seeking apartments near Johnson County Community College. Enjoy a convenient living experience with quick access to educational opportunities and local attractions.\n\nOur community features a range of polished one, two, and three-bedroom homes, including options with attached garages. Residents appreciate our amenities, like in-home washers and dryers, package service, and disability access. Find your ideal home at Wynnewood Farms and enjoy the perfect blend of comfort, style, and accessibility near Johnson County Community College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "South Overland Park Apartments Near JCCC",
      "seo_description": "Discover Wynnewood Farms, offering convenient living near Johnson County Community College in South Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "apartments-66209-overland-christian-school",
      "search_query": "apartments close to Overland Christian School in KS 66209",
      "category": "School",
      "h1_title": "Apts Close to Overland Christian School KS 66209",
      "h2_subtitle": "Experience the comfort of Wynnewood Farms, offering apartments close to Overland Christian School in 66209.",
      "page_copy": "Located in the heart of South Overland Park, Wynnewood Farms places you conveniently near Overland Christian School. Our community is perfect for families seeking quality education and a seamless living experience in the KS 66209 area.\n\nWynnewood Farms features a selection of one, two, and three-bedroom homes with thoughtful amenities such as stainless steel appliances and disability access. Some units offer attached garages and all include in-home washers and dryers, ensuring ultimate convenience. Come explore our serene setting and see why Wynnewood Farms is the ideal choice for those looking to stay close to Overland Christian School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Overland Christian in KS 66209",
      "seo_description": "Find ideal living at Wynnewood Farms apartments, close to Overland Christian School in KS 66209, with modern amenities and convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "wynnewood-apartments-near-overland-park-medical-center",
      "search_query": "apartments near overland park regional medical center wynnewood",
      "category": "Hospital",
      "h1_title": "Apts Near Overland Park Regional Medical Center",
      "h2_subtitle": "Discover Wynnewood Farms apartments, ideally situated near Overland Park Regional Medical Center for convenient living.",
      "page_copy": "Wynnewood Farms is the perfect choice for those seeking apartments near Overland Park Regional Medical Center. Nestled in Wynnewood, our community provides easy access to quality healthcare while offering a peaceful living environment.\n\nChoose from our diverse range of one, two, and three-bedroom apartment homes featuring upscale finishes and modern conveniences like stainless steel appliances and in-home washers and dryers. Enjoy community amenities, including package service and disability access, enhancing your living experience. Make Wynnewood Farms your new home and enjoy the proximity to Overland Park Regional Medical Center and everything the area has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wynnewood Apts Near Overland Park Medical Center",
      "seo_description": "Live near Overland Park Regional Medical Center at Wynnewood Farms, featuring modern apartments and convenient amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "apartments-near-overland-park-arboretum",
      "search_query": "apartments near overland park arboretum and botanical gardens",
      "category": "Park",
      "h1_title": "Apts Near Overland Park Arboretum & Gardens",
      "h2_subtitle": "Explore Wynnewood Farms apartments near the lush Overland Park Arboretum and Botanical Gardens.",
      "page_copy": "Wynnewood Farms offers charming living spaces just a short drive from the Overland Park Arboretum and Botanical Gardens. Nestled in South Overland Park, our community is perfect for nature enthusiasts seeking tranquility and access to beautiful landscapes.\n\nOur selection of one, two, and three-bedroom homes is designed to provide spacious comfort with features like in-home washers and dryers, stainless steel appliances, and available attached garages. With amenities such as package service and disability access, Wynnewood Farms meets all your living needs while keeping you close to the natural beauty of the Arboretum and Gardens.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Overland Park Arboretum & Gardens",
      "seo_description": "Discover Wynnewood Farms' serene living spaces near Overland Park Arboretum and Botanical Gardens, offering comfort and convenience in an ideal location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "apartments-close-to-gezer-park-overland-park",
      "search_query": "apartments close to gezer park overland park",
      "category": "Park",
      "h1_title": "Apts Close to Gezer Park, Overland Park",
      "h2_subtitle": "Discover Wynnewood Farms apartments, conveniently close to Gezer Park in Overland Park. Enjoy spacious living with great amenities.",
      "page_copy": "Situated in the welcoming community of Wynnewood, Wynnewood Farms offers perfectly located apartments close to Gezer Park, providing easy access to outdoor activities and scenic relaxation. Our property enjoys a prime location in Overland Park, ideal for individuals and families who love spending time in nature.\n\nChoose from our modern one, two, and three-bedroom apartment options, each equipped with elevated finishes such as stainless steel appliances, in-home washers and dryers, and some units even include attached garages. Community conveniences like package service and 24-hour access ensure a hassle-free lifestyle. Experience peaceful living just minutes from Gezer Park at Wynnewood Farms.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Gezer Park in Overland Park",
      "seo_description": "Wynnewood Farms offers spacious apartments near Gezer Park, Overland Park, combining modern amenities with a prime location for nature lovers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "yilan-park-proximity-apartments-wynnewood",
      "search_query": "yilan park proximity apartments wynnewood",
      "category": "Park",
      "h1_title": "Yilan Park Proximity Apts in Wynnewood",
      "h2_subtitle": "Live near Yilan Park at Wynnewood Farms, where comfortable living meets convenient park access.",
      "page_copy": "Wynnewood Farms presents an outstanding choice for those searching for apartments in proximity to Yilan Park. Nestled in the scenic setting of Wynnewood, our community provides easy access to the park's serene environment, ideal for leisure and recreation.\n\nOur one, two, and three-bedroom apartment homes are designed with modern living in mind, featuring stylish stainless steel appliances, in-home washers and dryers, and available attached garages. Residents benefit from thoughtful community amenities including package service, 24-hour access, and disability accessibility, making Wynnewood Farms the perfect place to call home only moments from Yilan Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Yilan Park Proximity Apartments in Wynnewood",
      "seo_description": "Discover Wynnewood Farms, offering modern living near Yilan Park with comfortable apartments and convenient amenities in a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "tomahawk-creek-bike-park-apartments-overland-park",
      "search_query": "tomahawk creek bike park nearby apartments overland park",
      "category": "Park",
      "h1_title": "Apts Near Tomahawk Creek Bike Park",
      "h2_subtitle": "Find your home at Wynnewood Farms, where nearby Tomahawk Creek Bike Park offers abundant outdoor adventures.",
      "page_copy": "Wynnewood Farms is ideally located for outdoor enthusiasts seeking apartments near Tomahawk Creek Bike Park in Overland Park. Our community offers easy access to biking trails and nature, perfect for an active lifestyle.\n\nChoose from our polished one, two, and three-bedroom homes, which boast modern features like in-home washers and dryers and stainless steel appliances. Select units even feature attached garages. With amenities such as disability access and 24-hour entry, Wynnewood Farms provides all the comforts of home with the added convenience of being close to Tomahawk Creek Bike Park for endless outdoor fun.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Tomahawk Creek Bike Park, Overland Park",
      "seo_description": "Live at Wynnewood Farms, offering apartments with modern amenities near Tomahawk Creek Bike Park in Overland Park, perfect for biking enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "living-near-tomahawk-park-johnson-county",
      "search_query": "living near tomahawk park johnson county",
      "category": "Park",
      "h1_title": "Live Near Tomahawk Park, Johnson County",
      "h2_subtitle": "Experience the joy of living near Tomahawk Park in Johnson County at Wynnewood Farms. Discover spacious, modern living in a prime location.",
      "page_copy": "Wynnewood Farms offers idyllic living near Tomahawk Park in Johnson County, providing the perfect blend of comfort and convenience. Our community is strategically placed for easy access to the parks and recreational opportunities at Tomahawk Park, making it a great choice for those who love the outdoors.\n\nResidents can enjoy spacious one, two, and three-bedroom homes enhanced with high-end finishes like stainless steel appliances and in-home washers and dryers. With options for attached garages and community amenities such as package service and accessibility features, Wynnewood Farms sets the standard for quality living near Tomahawk Park in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Live Near Tomahawk Park in Johnson County",
      "seo_description": "Discover Wynnewood Farms for modern living near Tomahawk Park, Johnson County. Enjoy comfort, style, and great community features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "apartments-by-hawthorne-valley-park-overland-park",
      "search_query": "apartments by hawthorne valley park overland park",
      "category": "Park",
      "h1_title": "Apt Living by Hawthorne Valley Park",
      "h2_subtitle": "Experience the charm of living near Hawthorne Valley Park at Wynnewood Farms, where apartment comfort meets outdoor convenience.",
      "page_copy": "Wynnewood Farms provides an ideal setting for those looking for apartments near Hawthorne Valley Park in Overland Park. With the park just a short distance away, our community is perfect for those who appreciate green spaces and outdoor activities.\n\nOur community features spacious one, two, and three-bedroom homes complete with stainless steel appliances, in-home washers and dryers, and the added option of attached garages. Residents enjoy amenities such as package service, 24-hour access, and disability accommodation. Discover the perfect blend of accessibility and luxury living at Wynnewood Farms, just moments from Hawthorne Valley Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Hawthorne Valley Park, Overland Park",
      "seo_description": "Live at Wynnewood Farms, offering modern apartments near Hawthorne Valley Park in Overland Park. Enjoy easy park access and community comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "beth-torah-park-close-by-wynnewood",
      "search_query": "beth torah park close by wynnewood",
      "category": "Park",
      "h1_title": "Close to Beth Torah Park: Wynnewood Living",
      "h2_subtitle": "Enjoy living near Beth Torah Park in Wynnewood at Wynnewood Farms. Discover community comforts and a vibrant neighborhood atmosphere.",
      "page_copy": "Nestled in the vibrant neighborhood of Wynnewood, Wynnewood Farms offers convenient living close to Beth Torah Park, making it an excellent choice for residents seeking outdoor leisure and tranquility. This location offers an enviable proximity to relaxing green spaces, ensuring plenty of fresh air and natural beauty.\n\nOur community features beautifully designed one, two, and three-bedroom apartments with modern finishes, including stainless steel appliances and in-home washers and dryers. Select units have attached garages and additional amenities include a package service and 24-hour access. Experience a harmonious blend of serenity and style at Wynnewood Farms, your gateway to a peaceful living environment near Beth Torah Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Live Close to Beth Torah Park, Wynnewood",
      "seo_description": "Wynnewood Farms offers stylish apartments near Beth Torah Park. Enjoy modern amenities and peaceful park proximity in Wynnewood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "nall-hills-park-vicinity-apartments-66209",
      "search_query": "nall hills park vicinity apartments 66209",
      "category": "Park",
      "h1_title": "Apartments Near Nall Hills Park, 66209",
      "h2_subtitle": "Discover spacious living in the 66209 area, close to Nall Hills Park. Wynnewood Farms offers modern apartments with comfortable amenities.",
      "page_copy": "At Wynnewood Farms, find your dream home in the heart of Overland Park, close to Nall Hills Park in the sought-after 66209 ZIP code. Our community offers the advantages of easy park access within a peaceful and welcoming environment, perfect for anyone looking to enjoy the great outdoors.\n\nChoose from our selection of one, two, and three-bedroom apartments featuring high-end finishes like stainless steel appliances and in-home washers and dryers. With options such as attached garages and community perks including a package service and round-the-clock access, Wynnewood Farms is the ideal choice for apartment living near Nall Hills Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Find Apartments Near Nall Hills Park, 66209",
      "seo_description": "Explore modern living at Wynnewood Farms, offering beautiful apartments near Nall Hills Park in zip code 66209 with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167624",
      "source": "generator",
      "page_item_url": "apartments-near-kansas-city-international-airport",
      "search_query": "apartments near kansas city international airport overland park",
      "category": "Transit",
      "h1_title": "Convenient Apartments Near KCI Airport",
      "h2_subtitle": "Enjoy the convenience of living near Kansas City International Airport with stylish apartments at Wynnewood Farms in Overland Park.",
      "page_copy": "Wynnewood Farms offers a perfect home base for those seeking apartments near Kansas City International Airport in Overland Park. Ideal for frequent travelers, our community combines the comforts of home with easy airport access.\n\nChoose from our one, two, and three-bedroom residences featuring upscale stainless steel appliances, in-home washers and dryers, and optional attached garages. Our community amenities, such as package service, disability access, and 24-hour service, enhance your living experience. Experience a seamless blend of travel convenience and residential comfort at Wynnewood Farms.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
      "featured_image_media": {
        "alt_text": "View from a balcony overlooking a residential area with buildings and trees.",
        "public_id": "019fc991-cbd2-7232-85ca-93f1896995cf",
        "storage_key": "property/6767906449167624/019fc991-cbd2-7232-85ca-93f1896995cf.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City International Airport",
      "seo_description": "Discover Wynnewood Farms, offering apartments near KCI Airport with modern amenities, perfect for travelers in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701891345"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KLK9M9D2"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 5"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/9bf3f2b6-c86e-467a-a072-08351f310ba6/app.js?nocache=1&gaTracking=GT-MB8JGC4N&buttonbgcolor=00573f&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "39401883318"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-728-5805"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImxBTythOHFDRzBBZlhUVGxsSkdOVmc9PSIsInZhbHVlIjoic3kzaEtQbGJYVFY2QWlWVXlMVm4wdz09IiwibWFjIjoiNjJkZDc1ZTcwMTNiMTRlZTM5YzU3NDUzZDQxMTE1MTJmODZhYjkzODUyYzRhYmQwZTE1MmZiYmJiZDI1NWFmNSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701891345",
  "custom_google_gtm_id": "GTM-KLK9M9D2",
  "custom_rollout_phase": "Batch 5",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/9bf3f2b6-c86e-467a-a072-08351f310ba6/app.js?nocache=1&gaTracking=GT-MB8JGC4N&buttonbgcolor=00573f&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "39401883318",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-728-5805",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImxBTythOHFDRzBBZlhUVGxsSkdOVmc9PSIsInZhbHVlIjoic3kzaEtQbGJYVFY2QWlWVXlMVm4wdz09IiwibWFjIjoiNjJkZDc1ZTcwMTNiMTRlZTM5YzU3NDUzZDQxMTE1MTJmODZhYjkzODUyYzRhYmQwZTE1MmZiYmJiZDI1NWFmNSJ9",
  "custom_audioeye_site_id": "95a9013b-d750-4b88-ac40-c2a62333bbdc",
  "custom_audioeye_site_hash": "f54f7f3a6c7acde1e328e993890ade5a"
};

export const generatedAt = '2026-11-03T22:56:54.466Z';
